"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[44975],{

/***/ 44975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MultiPortoModalManager; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/features/multi-porto/stores/modal.store.ts
var modal_store = __webpack_require__(3683);
// EXTERNAL MODULE: ./src/features/multi-porto/hooks/useSubAccounts.ts
var useSubAccounts = __webpack_require__(65361);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 1 modules
var BaseSecuritiesModal = __webpack_require__(48871);
// EXTERNAL MODULE: ./src/stores/useUIConfigStore/index.ts + 1 modules
var useUIConfigStore = __webpack_require__(7639);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateOnboarding/onboarding.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 40px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  line-height: 32px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-style: normal;\n  font-weight: 400;\n  margin: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #00ab6b;\n  color: #00ab6b;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ca7343-0"
})(_templateObject());
var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ca7343-1"
})(_templateObject1());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ca7343-2"
})(_templateObject2());
var Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-67ca7343-3"
})(_templateObject3());
var Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-67ca7343-4"
})(_templateObject4());
var ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-67ca7343-5"
})(_templateObject5());
var NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-67ca7343-6"
})(_templateObject6());
var CancelButton = (0,styled_components_browser_esm/* default */.ZP)(NextButton).withConfig({
    componentId: "sc-67ca7343-7"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateOnboarding/index.tsx








var CreatePortoOnboardinng = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var setUIValue = (0,useUIConfigStore/* default */.Z)(function(s) {
        return s.setUIValue;
    });
    var handleDismiss = function() {
        setUIValue("multiPortfolioOnboardingEligible", true);
    };
    var handleSubmit = function() {
        onSubmit();
        handleDismiss();
    };
    var handleCancel = function(e) {
        onCancel(e);
        handleDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: "/images/multi-porto/onboarding.svg",
                        alt: "",
                        width: 420,
                        height: 250
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                            children: "Multiple Portfolio"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                            children: "Buat portfolio baru untuk mengoptimalkan strategi investasi kamu."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            children: "Buat Portfolio Baru"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                            onClick: handleCancel,
                            children: "Nanti Aja"
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var CreateOnboarding = (CreatePortoOnboardinng);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/es/radio/index.js + 4 modules
var es_radio = __webpack_require__(29924);
// EXTERNAL MODULE: ./src/lib/stores/multiPorto.ts
var multiPorto = __webpack_require__(34385);
;// CONCATENATED MODULE: ./src/features/multi-porto/hooks/usePortfolioCreation.ts

function usePortfolioForm() {
    var initialName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref = (0,react.useState)(initialName), portfolioName = ref[0], setPortfolioName = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var handlePortfolioNameChange = function(e) {
        var value = e.target.value;
        setPortfolioName(value);
        var trimmedValue = value.trim(); // Trim the input value
        var regex = /^[a-zA-Z0-9\s]+$/; // Allow letters, numbers, and spaces
        if (!trimmedValue) {
            setError("");
            return;
        }
        if (!regex.test(trimmedValue)) {
            setError("Portfolio Name cannot contain special characters");
            return;
        }
        setError("");
    };
    var resetForm = function() {
        setPortfolioName("");
        setError("");
    };
    return {
        portfolioName: portfolioName,
        error: error,
        setPortfolioName: setPortfolioName,
        handlePortfolioNameChange: handlePortfolioNameChange,
        resetForm: resetForm
    };
};

// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 8 modules
var input = __webpack_require__(7648);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreatePorto/create.styled.ts

function create_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .ant-form-item-label {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n  }\n\n  .radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .ant-radio-wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-radio {\n    top: 0;\n  }\n"
    ]);
    create_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function create_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  height: 50px;\n  font-size: 14px;\n  border: 1px solid #EDEDED;\n  box-shadow: none;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &:focus-within {\n    border-color: #00ab6b;\n  }\n\n  ",
        "\n"
    ]);
    create_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function create_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #EE4A49;\n  font-size: 12px;\n  line-height: 19px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    create_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function create_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 19px;\n  color: #858585;\n\n  ",
        "\n"
    ]);
    create_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function create_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n"
    ]);
    create_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function create_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  .ant-radio-wrapper {\n    display: flex;\n    align-items: center;\n    width: min-content;\n    text-wrap: nowrap;\n  }\n\n  .ant-radio {\n    display: inline-flex;\n    align-items: center;\n  }\n\n  /* Default radio button styling */\n  .ant-radio-inner {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    border: 2px solid #CBCBCB;\n    position: relative;\n    transition: none;\n    animation: none;\n  }\n\n  /* Hide default pseudo-element */\n  .ant-radio-inner::before {\n    display: none;\n  }\n\n  /* Checked state: green circle with checkmark */\n  .ant-radio-checked .ant-radio-inner {\n    border-color: #00AB6B;\n    background-color: #00AB6B;\n  }\n\n  /* Add checkmark when checked */\n  .ant-radio-checked .ant-radio-inner::after {\n    content: "";\n    position: absolute;\n    display: block;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 2px 2px 0;\n    top: 1px;\n    left: 5px;\n    transform: rotate(45deg);\n  }\n\n  .ant-radio-inner::after {\n    transition: none;\n  }\n'
    ]);
    create_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var create_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9d2bf58-0"
})(create_styled_templateObject());
var InputStyled = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.Z).withConfig({
    componentId: "sc-b9d2bf58-1"
})(create_styled_templateObject1(), function(props) {
    return props.isErrored && "\n    border-color: #EE4A49;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &:focus-within {\n      border-color: #EE4A49 !important;\n    }\n  ";
});
var InputError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9d2bf58-2"
})(create_styled_templateObject2());
var CharCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b9d2bf58-3"
})(create_styled_templateObject3(), function(props) {
    return props.isErrored && "\n    color: #EE4A49;\n  ";
});
var create_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-b9d2bf58-4"
})(create_styled_templateObject4());
var StyledRadioGroup = (0,styled_components_browser_esm/* default */.ZP)(es_radio/* default.Group */.ZP.Group).withConfig({
    componentId: "sc-b9d2bf58-5"
})(create_styled_templateObject5());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreatePorto/index.tsx












var CreatePortoOnboarding = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var ref2 = (0,react.useState)(undefined), purpose = ref2[0], setPurpose = ref2[1];
    var purposesData = (0,multiPorto/* default */.Z)(function(s) {
        return s.subAccountsPurposeData;
    });
    var ref3;
    var purposeList = (ref3 = (ref = purposesData.data) === null || ref === void 0 ? void 0 : ref.purposes) !== null && ref3 !== void 0 ? ref3 : [];
    var getPurposes = (0,multiPorto/* default */.Z)(function(s) {
        return s.getPurposes;
    });
    var setPortfolioForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.setPortfolioForm;
    });
    var ref4 = usePortfolioForm(), portfolioName = ref4.portfolioName, error = ref4.error, handlePortfolioNameChange = ref4.handlePortfolioNameChange, resetForm = ref4.resetForm;
    var handleReset = function() {
        resetForm();
        setPurpose(undefined);
        form.resetFields();
    };
    var handleSubmit = function() {
        onSubmit();
        setPortfolioForm({
            portfolio_name: portfolioName.trim(),
            tnc: {
                feature_id: "",
                version: 0
            },
            purpose: purpose
        });
        handleReset();
    };
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
    };
    (0,react.useEffect)(function() {
        if (props.visible) getPurposes();
    }, [
        props.visible,
        getPurposes
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Create New Portfolio",
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(create_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                layout: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                        name: "portfolio",
                        label: "Portfolio Name",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStyled, {
                                value: portfolioName,
                                onChange: handlePortfolioNameChange,
                                maxLength: 20,
                                placeholder: "Input Portfolio Name",
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CharCount, {
                                    isErrored: !!error,
                                    children: [
                                        portfolioName.length,
                                        "/20"
                                    ]
                                }),
                                isErrored: !!error
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputError, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/alert/warning.svg",
                                        alt: "Error"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: error
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        name: "purpose",
                        label: "Purpose",
                        initialValue: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRadioGroup, {
                            onChange: function(e) {
                                return setPurpose(e.target.value);
                            },
                            value: purpose,
                            className: "radio-group",
                            children: purposeList.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_radio/* default */.ZP, {
                                    value: item.type,
                                    children: item.text
                                }, item.type);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(create_styled_NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            disabled: !portfolioName || !!error || !purpose,
                            children: "Continue"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var CreatePorto = (CreatePortoOnboarding);

// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateRenamePorto/rename.styled.ts

function rename_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .ant-form-item-label {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n  }\n\n  .radio-group {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .ant-radio-wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-radio {\n    top: 0;\n  }\n"
    ]);
    rename_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function rename_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  height: 50px;\n  font-size: 14px;\n  border: 1px solid #EDEDED;\n  box-shadow: none;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &:focus-within {\n    border-color: #00ab6b;\n  }\n\n  ",
        "\n"
    ]);
    rename_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function rename_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #EE4A49;\n  font-size: 12px;\n  line-height: 19px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    rename_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function rename_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  line-height: 19px;\n  color: #858585;\n\n  ",
        "\n"
    ]);
    rename_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function rename_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n  margin-top: 16px;\n"
    ]);
    rename_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var rename_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74e7f275-0"
})(rename_styled_templateObject());
var rename_styled_InputStyled = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.Z).withConfig({
    componentId: "sc-74e7f275-1"
})(rename_styled_templateObject1(), function(props) {
    return props.isErrored && "\n    border-color: #EE4A49;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &:focus-within {\n      border-color: #EE4A49 !important;\n    }\n  ";
});
var rename_styled_InputError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74e7f275-2"
})(rename_styled_templateObject2());
var rename_styled_CharCount = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-74e7f275-3"
})(rename_styled_templateObject3(), function(props) {
    return props.isErrored && "\n    color: #EE4A49;\n  ";
});
var rename_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-74e7f275-4"
})(rename_styled_templateObject4());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateRenamePorto/index.tsx















var RenamePortfolio = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var renameForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.renamePortfolioForm;
    });
    var postRenamePorto = (0,multiPorto/* default */.Z)(function(s) {
        return s.postRenamePorto;
    });
    var ref2 = usePortfolioForm(), portfolioName = ref2.portfolioName, error = ref2.error, setPortfolioName = ref2.setPortfolioName, handlePortfolioNameChange = ref2.handlePortfolioNameChange, resetForm = ref2.resetForm;
    var handleReset = function() {
        resetForm();
        form.resetFields();
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var payload, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, renameForm), {
                            new_portfolio_name: portfolioName,
                            idempotency_ref: "WEB-Rename-Porto-".concat(Date.now())
                        });
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return postRenamePorto(payload);
                    case 5:
                        result = _ctx.sent;
                        if (typeof result === "boolean" && result) {
                            onSubmit();
                            handleReset();
                            (0,AlertMessage/* default */.Z)({
                                content: "Portfolio Name Has Been Changed",
                                alertType: "snackbar-dark",
                                messageType: "success",
                                hasCloseIcon: true
                            });
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                    case 12:
                        setLoading(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    9
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
    };
    (0,react.useEffect)(function() {
        if (renameForm.new_portfolio_name) {
            setPortfolioName(renameForm.new_portfolio_name);
        }
    }, [
        renameForm.new_portfolio_name
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Rename Portfolio",
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rename_styled_Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                layout: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                        name: "portfolio",
                        label: "Portfolio Name",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(rename_styled_InputStyled, {
                                value: portfolioName,
                                onChange: handlePortfolioNameChange,
                                maxLength: 20,
                                placeholder: "Input Portfolio Name",
                                suffix: /*#__PURE__*/ (0,jsx_runtime.jsxs)(rename_styled_CharCount, {
                                    isErrored: !!error,
                                    children: [
                                        portfolioName.length,
                                        "/20"
                                    ]
                                }),
                                isErrored: !!error
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(rename_styled_InputError, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/alert/warning.svg",
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: error
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(rename_styled_NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            disabled: !portfolioName || !!error || loading || portfolioName === renameForm.new_portfolio_name,
                            loading: loading,
                            children: "Save"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var CreateRenamePorto = (RenamePortfolio);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LoadingOutlined.js + 1 modules
var LoadingOutlined = __webpack_require__(50888);
// EXTERNAL MODULE: ./src/global/Common/If.tsx
var If = __webpack_require__(3897);
// EXTERNAL MODULE: ./src/global/Securities/components/Checkbox/index.tsx
var Checkbox = __webpack_require__(19254);
// EXTERNAL MODULE: ./src/global/Securities/stores/useTermsAndConditionStore.ts
var useTermsAndConditionStore = __webpack_require__(24383);
// EXTERNAL MODULE: ./src/global/Securities/types/termsAndCondition.ts
var termsAndCondition = __webpack_require__(13114);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateTnc/terms.styled.ts

function terms_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 20px 20px;\n  box-sizing: border-box;\n"
    ]);
    terms_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function terms_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  gap: 8px;\n"
    ]);
    terms_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function terms_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    terms_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function terms_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  height: 450px;\n"
    ]);
    terms_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function terms_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(255, 255, 255, 0.9);\n  z-index: 10;\n"
    ]);
    terms_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function terms_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n  max-height: 445px;\n"
    ]);
    terms_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function terms_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n"
    ]);
    terms_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function terms_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0 0;\n"
    ]);
    terms_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 40px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  cursor: pointer;\n\n  &:disabled {\n    background-color: #cceee1 !important;\n    color: #ffffff !important;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var terms_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a69b8e8-0"
})(terms_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a69b8e8-1"
})(terms_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-4a69b8e8-2"
})(terms_styled_templateObject2());
var TnCWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a69b8e8-3"
})(terms_styled_templateObject3());
var TnCLoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a69b8e8-4"
})(terms_styled_templateObject4());
var TnCFrame = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
    componentId: "sc-4a69b8e8-5"
})(terms_styled_templateObject5());
var AgreementTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a69b8e8-6"
})(terms_styled_templateObject6());
var terms_styled_ActionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a69b8e8-7"
})(terms_styled_templateObject7());
var terms_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-4a69b8e8-8"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateTnc/index.tsx

















var CreatePortoTnc = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(false), tncAgreed = ref1[0], setTncAgreed = ref1[1];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react.useState)(true), iframeLoading = ref3[0], setIframeLoading = ref3[1];
    var createForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.createPortfolioForm;
    });
    var postCreatePorto = (0,multiPorto/* default */.Z)(function(s) {
        return s.postCreatePorto;
    });
    var termsData = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.termsData;
    });
    var multiPortoTnc = termsData === null || termsData === void 0 ? void 0 : termsData[termsAndCondition/* TnCFeaturesIDEnum.MULTI_PORTO */.el.MULTI_PORTO];
    var loadTnCAcceptance = (0,useTermsAndConditionStore/* default */.Z)(function(s) {
        return s.loadTnCAcceptance;
    });
    var handleReset = function() {
        setTncAgreed(false);
        form.resetFields();
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var payload, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, createForm), {
                            tnc: {
                                feature_id: termsAndCondition/* TnCFeaturesIDEnum.MULTI_PORTO */.el.MULTI_PORTO,
                                version: multiPortoTnc === null || multiPortoTnc === void 0 ? void 0 : multiPortoTnc.version
                            },
                            idempotency_ref: "WEB-Create-Porto-".concat(Date.now())
                        });
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return postCreatePorto(payload);
                    case 5:
                        result = _ctx.sent;
                        if (typeof result === "boolean" && result) {
                            onSubmit();
                            handleReset();
                        }
                        _ctx.next = 12;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                    case 12:
                        setLoading(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    9
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
    };
    var handleCheckboxChange = function(event) {
        setTncAgreed(event.target.checked);
    };
    (0,react.useEffect)(function() {
        if (props.visible) {
            loadTnCAcceptance([
                termsAndCondition/* TnCFeaturesIDEnum.MULTI_PORTO */.el.MULTI_PORTO
            ]);
        }
    }, [
        props.visible,
        loadTnCAcceptance
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Syarat & Ketentuan",
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TnCWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: iframeLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCLoadingWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingOutlined/* default */.Z, {
                                        style: {
                                            color: "#00AB6B",
                                            fontSize: "20px"
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: !!(multiPortoTnc === null || multiPortoTnc === void 0 ? void 0 : multiPortoTnc.url),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                                    title: "multi-porto-tnc",
                                    src: multiPortoTnc === null || multiPortoTnc === void 0 ? void 0 : multiPortoTnc.url,
                                    id: "tnc-multi-porto",
                                    onLoad: function() {
                                        return setIframeLoading(false);
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AgreementWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                    checked: tncAgreed,
                                    onChange: handleCheckboxChange
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AgreementTextWrapper, {
                                    children: "Saya menyetujui aturan penggunaan dan Kebijakan Privasi untuk pemrosesan data pribadi saya di Stockbit."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_styled_ActionWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(terms_styled_NextButton, {
                                onClick: handleSubmit,
                                type: "primary",
                                disabled: !tncAgreed || loading,
                                loading: loading,
                                children: "Create"
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var CreateTnc = (CreatePortoTnc);

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateSuccess/success.styled.ts

function success_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  img {\n    width: 160px;\n    height: 120px;\n    align-self: center;\n  }\n\n  &.error-create-porto {\n    gap: 16px;\n\n    button {\n      margin-top: 24px;\n    }\n  }\n"
    ]);
    success_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function success_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n"
    ]);
    success_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function success_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 22px;\n  margin: 0;\n"
    ]);
    success_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function success_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 19px;\n  margin: 0;\n  color: #858585;\n"
    ]);
    success_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function success_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 160px;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n  align-self: center;\n"
    ]);
    success_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var success_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70bf1f90-0"
})(success_styled_templateObject());
var success_styled_ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-70bf1f90-1"
})(success_styled_templateObject1());
var success_styled_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-70bf1f90-2"
})(success_styled_templateObject2());
var success_styled_Description = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-70bf1f90-3"
})(success_styled_templateObject3());
var FinishButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-70bf1f90-4"
})(success_styled_templateObject4());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateSuccess/index.tsx







var CreatePortoSuccess = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var handleSubmit = function() {
        onSubmit();
    };
    var handleCancel = function(e) {
        onCancel(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(success_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/multi-porto/success-create-porto.svg",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(success_styled_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(success_styled_Title, {
                            children: "Portofolio Baru Kamu Telah Diajukan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(success_styled_Description, {
                            children: "Proses ini membutuhkan verifikasi selama 1 hari kerja."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishButton, {
                    onClick: handleSubmit,
                    type: "primary",
                    children: "OK"
                })
            ]
        })
    }));
};
/* harmony default export */ var CreateSuccess = (CreatePortoSuccess);

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Create/CreateError/index.tsx








var CreatePortoError = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var cannotCreateData = (0,multiPorto/* default */.Z)(function(s) {
        var ref;
        return (ref = s.subAccountsData.data) === null || ref === void 0 ? void 0 : ref.can_not_create_new_sub_account_reason;
    });
    var handleSubmit = function() {
        onSubmit();
    };
    var handleCancel = function(e) {
        onCancel(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto error",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(success_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            className: "error-create-porto",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/multi-porto/error-create-porto.svg",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(success_styled_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(success_styled_Title, {
                            children: cannotCreateData === null || cannotCreateData === void 0 ? void 0 : cannotCreateData.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(success_styled_Description, {
                            children: cannotCreateData === null || cannotCreateData === void 0 ? void 0 : cannotCreateData.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FinishButton, {
                    onClick: handleSubmit,
                    type: "primary",
                    children: "OK"
                })
            ]
        })
    }));
};
/* harmony default export */ var CreateError = (CreatePortoError);

// EXTERNAL MODULE: ./src/features/multi-porto/hooks/useSwitchAction.ts
var useSwitchAction = __webpack_require__(74981);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferSelect/select.styled.ts

function select_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    select_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function select_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  width: 100%;\n  height: 56px;\n  border-radius: 4px;\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 700;\n  cursor: pointer;\n  border: 1px solid #EDEDED;\n\n  &:hover {\n    background-color: #F7F7F7;\n  }\n\n  & > div {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: #333333;\n  }\n"
    ]);
    select_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var select_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f55f85ef-0"
})(select_styled_templateObject());
var SelectButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f55f85ef-1"
})(select_styled_templateObject1());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferSelect/index.tsx








function TransferSelect(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,useSwitchAction/* default */.Z)(), onOpenTransferCash = ref.onOpenTransferCash, onOpenTransferStock = ref.onOpenTransferStock;
    var handleOpenTransferCash = function() {
        onSubmit();
        onOpenTransferCash();
    };
    var handleOpenTransferStock = function() {
        onSubmit();
        onOpenTransferStock();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Select Asset",
        hideSubmit: true,
        onCancel: onCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(select_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectButton, {
                    onClick: handleOpenTransferCash,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/multi-porto/transfer-cash.svg",
                                    alt: "",
                                    height: 20,
                                    width: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Transfer Cash"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/chevron-right-gray.svg",
                            alt: "",
                            height: 16,
                            width: 16
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectButton, {
                    onClick: handleOpenTransferStock,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/multi-porto/transfer-stock.svg",
                                    alt: "",
                                    height: 20,
                                    width: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Transfer Stock"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/chevron-right-gray.svg",
                            alt: "",
                            height: 16,
                            width: 16
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/features/multi-porto/hooks/usePortfolioSelect.ts



function usePortfolioSelect(param) {
    var visible = param.visible, form = param.form;
    var ref = (0,react.useState)(null), fromPortfolio = ref[0], setFromPortfolio = ref[1];
    var ref1 = (0,react.useState)(null), toPortfolio = ref1[0], setToPortfolio = ref1[1];
    var activeAccount = (0,multiPorto/* default */.Z)(function(s) {
        return s.activeAccount;
    });
    // sub accounts
    var getSubAccounts = (0,multiPorto/* default */.Z)(function(s) {
        return s.getSubAccounts;
    });
    var approvedSubAccounts = (0,useSubAccounts/* default */.Z)().approvedSubAccounts;
    var disabledSelect = (0,react.useMemo)(function() {
        return approvedSubAccounts.length <= 2;
    }, [
        approvedSubAccounts.length
    ]);
    var mapPortfolioOptions = function(_subAccounts, exclude) {
        return _subAccounts.filter(function(param) {
            var account_number = param.account_number;
            return account_number !== exclude;
        }).map(function(acc) {
            return {
                label: acc.portfolio_info.portfolio_name,
                value: acc.account_number,
                isMain: acc.is_main_account
            };
        });
    };
    var fromPortfolioOptions = (0,react.useMemo)(function() {
        return mapPortfolioOptions(approvedSubAccounts, toPortfolio);
    }, [
        approvedSubAccounts.length,
        toPortfolio,
        visible
    ]);
    var toPortfolioOptions = (0,react.useMemo)(function() {
        return mapPortfolioOptions(approvedSubAccounts, fromPortfolio);
    }, [
        approvedSubAccounts.length,
        fromPortfolio,
        visible
    ]);
    var handleChangeFromPortfolio = function(value) {
        setFromPortfolio(value);
        // if value is selected in toPortfolio, remove it from fromPortfolio
        if (toPortfolio === value) {
            setToPortfolio(null);
            form.setFieldsValue({
                toPortfolio: null
            });
            return;
        }
        var options = mapPortfolioOptions(approvedSubAccounts, value) || [];
        var availableToOptions = options.filter(function(subAccount) {
            return subAccount.value !== value;
        });
        if (availableToOptions.length === 1) {
            form.setFieldsValue({
                toPortfolio: availableToOptions[0].value
            });
            setToPortfolio(availableToOptions[0].value);
        }
    };
    var handleChangeToPortfolio = function(value) {
        setToPortfolio(value);
        // if value is selected in fromPortfolio, remove it from toPortfolio
        if (fromPortfolio === value) {
            setFromPortfolio(null);
            form.setFieldsValue({
                fromPortfolio: null
            });
            return;
        }
        var options = mapPortfolioOptions(approvedSubAccounts, value) || [];
        var availableFromOptions = options.filter(function(subAccount) {
            return subAccount.value !== value;
        });
        if (availableFromOptions.length === 1) {
            form.setFieldsValue({
                fromPortfolio: availableFromOptions[0].value
            });
            setFromPortfolio(availableFromOptions[0].value);
        }
    };
    var handleSwitchPortfolio = function() {
        if (!fromPortfolio && !toPortfolio) return;
        if (fromPortfolio && toPortfolio) {
            var tempFromPortfolio = fromPortfolio;
            var tempToPortfolio = toPortfolio;
            setFromPortfolio(tempToPortfolio);
            form.setFieldsValue({
                fromPortfolio: tempToPortfolio
            });
            setToPortfolio(tempFromPortfolio);
            form.setFieldsValue({
                toPortfolio: tempFromPortfolio
            });
        }
        if (fromPortfolio && !toPortfolio) {
            setToPortfolio(fromPortfolio);
            form.setFieldsValue({
                toPortfolio: fromPortfolio
            });
            setFromPortfolio(null);
            form.setFieldsValue({
                fromPortfolio: null
            });
        }
        if (!fromPortfolio && toPortfolio) {
            setFromPortfolio(toPortfolio);
            form.setFieldsValue({
                fromPortfolio: toPortfolio
            });
            setToPortfolio(null);
            form.setFieldsValue({
                toPortfolio: null
            });
        }
    };
    var handleReset = function() {
        setFromPortfolio(null);
        setToPortfolio(null);
        form.resetFields();
    };
    // Set default fromPortfolio and toPortfolio
    (0,react.useEffect)(function() {
        if (!visible) return;
        if (approvedSubAccounts.length === 2 && !fromPortfolio && !toPortfolio) {
            var fromAccount = approvedSubAccounts.find(function(acc) {
                return acc.account_number === activeAccount;
            });
            var toAccount = approvedSubAccounts.find(function(acc) {
                return acc.account_number !== activeAccount;
            });
            setFromPortfolio((fromAccount === null || fromAccount === void 0 ? void 0 : fromAccount.account_number) || null);
            form.setFieldsValue({
                fromPortfolio: (fromAccount === null || fromAccount === void 0 ? void 0 : fromAccount.account_number) || null
            });
            setToPortfolio((toAccount === null || toAccount === void 0 ? void 0 : toAccount.account_number) || null);
            form.setFieldsValue({
                toPortfolio: (toAccount === null || toAccount === void 0 ? void 0 : toAccount.account_number) || null
            });
        }
        if (approvedSubAccounts.length > 2 && !fromPortfolio) {
            var fromAccount1 = approvedSubAccounts.find(function(acc) {
                return acc.account_number === activeAccount;
            });
            setFromPortfolio((fromAccount1 === null || fromAccount1 === void 0 ? void 0 : fromAccount1.account_number) || null);
            form.setFieldsValue({
                fromPortfolio: (fromAccount1 === null || fromAccount1 === void 0 ? void 0 : fromAccount1.account_number) || null
            });
        }
    }, [
        approvedSubAccounts.length,
        activeAccount,
        visible
    ]);
    // Get sub accounts data when modal is visible
    (0,react.useEffect)(function() {
        if (visible) getSubAccounts();
    }, [
        visible,
        getSubAccounts
    ]);
    return {
        fromPortfolio: fromPortfolio,
        fromPortfolioOptions: fromPortfolioOptions,
        toPortfolio: toPortfolio,
        toPortfolioOptions: toPortfolioOptions,
        disabledSelect: disabledSelect,
        onChangeFromPortfolio: handleChangeFromPortfolio,
        onChangeToPortfolio: handleChangeToPortfolio,
        onSwitchPortfolio: handleSwitchPortfolio,
        onReset: handleReset
    };
};

// EXTERNAL MODULE: ./src/features/securities/withdrawal/utils.ts
var utils = __webpack_require__(17921);
// EXTERNAL MODULE: ./src/features/securities/utils.tsx
var securities_utils = __webpack_require__(4621);
// EXTERNAL MODULE: ./src/features/securities/withdrawal/types.ts
var types = __webpack_require__(78765);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 49 modules
var es_select = __webpack_require__(92961);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferPortfolioSelect/index.tsx

function TransferPortfolioSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 100%;\n  border-bottom: 1px solid red;\n\n  &:last-child {\n    border-bottom: none;\n  }\n\n  .option-text {\n    display: flex;\n  }\n\n  .option-text .main-porto {\n    display: none;\n    margin-left: 4px;\n    color: #858585;\n    font-weight: 400;\n    font-family: ProximaNovaRg;\n  }\n\n  .sub-text {\n    color: gray;\n    font-size: 12px;\n  }\n\n  img {\n    display: none;\n  }\n"
    ]);
    TransferPortfolioSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var CustomOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b48373fb-0"
})(TransferPortfolioSelect_templateObject());
var PortfolioSelect = function(param) {
    var id = param.id, label = param.label, name = param.name, value = param.value, options = param.options, onChange = param.onChange, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
        name: name,
        label: label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: "".concat(id, "-select-").concat(name),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                placeholder: "Select Portfolio",
                value: value,
                onChange: onChange,
                suffixIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/icon/chevron-down.svg",
                    alt: ""
                }),
                style: {
                    width: "100%"
                },
                transitionName: "",
                disabled: disabled,
                getPopupContainer: function() {
                    return document.getElementById("".concat(id, "-select-").concat(name));
                },
                children: options.map(function(subAccount) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default.Option */.Z.Option, {
                        value: subAccount.value,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CustomOption, {
                            className: "transfer-custom-select",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "option-text",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "main-text",
                                            children: subAccount.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: subAccount.isMain,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "main-porto",
                                                children: " • Main"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/check/filled.svg",
                                    alt: "check-icon",
                                    width: 18,
                                    height: 18,
                                    className: "transfer-check-icon"
                                })
                            ]
                        })
                    }, subAccount.value);
                })
            })
        })
    });
};
/* harmony default export */ var TransferPortfolioSelect = (PortfolioSelect);

// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCash/cash.styled.ts

function cash_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  .ant-form-item-label {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n  }\n\n  .ant-select {\n    cursor: default;\n  }\n\n  .ant-select-selector {\n    cursor: pointer;\n  }\n"
    ]);
    cash_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cash_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #EDEDED;\n  border-radius: 4px;\n  margin-bottom: 24px;\n  position: relative;\n\n  .ant-form-item {\n    margin-bottom: 0;\n    padding-top: 10px;\n  }\n\n  .ant-form-item:first-child {\n    padding-bottom: 1px;\n  }\n\n  .ant-form-item:last-child {\n    border-top: 1px solid #EDEDED;\n  }\n\n  .ant-form-item-label {\n    padding: 0;\n    padding-left: 12px;\n  }\n\n  .ant-form-item-label > label {\n    font-size: 13px;\n    line-height: 18px;\n    font-weight: 400;\n    color: #858585 !important;\n  }\n\n  .ant-select-selector {\n    border: none !important;\n  }\n\n  .ant-select-selection-item {\n    color: #333333 !important;\n    font-weight: 700;\n  }\n\n  .ant-form-item .ant-select {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-select .ant-select-selector {\n    width: unset !important;\n  }\n\n  .ant-select-arrow {\n    position: relative;\n    margin-left: -10px;\n  }\n"
    ]);
    cash_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cash_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  height: 50px;\n  font-size: 14px;\n  border: 1px solid #EDEDED;\n  box-shadow: none;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &:focus-within {\n    border-color: #00ab6b;\n  }\n\n  ",
        "\n"
    ]);
    cash_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cash_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #EE4A49;\n  font-size: 12px;\n  line-height: 19px;\n  margin-top: 2px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    cash_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cash_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n  color: #858585;\n  font-size: 14px;\n  line-height: 19px;\n"
    ]);
    cash_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function cash_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  &.clickable {\n    cursor: pointer;\n    color: #333333;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    cash_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function cash_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100px;\n  height: 16px !important;\n  border-radius: 4px;\n"
    ]);
    cash_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function cash_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n"
    ]);
    cash_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function cash_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  color: #333333;\n  background: #ffffff;\n  font-size: 14px;\n  line-height: 19px;\n  border: 1px solid #EDEDED;\n  border-radius: 50px;\n  width: 28px;\n  height: 28px;\n\n  position: absolute;\n  right: 16px;\n  top: 47px;\n  z-index: 1;\n\n  img {\n    cursor: pointer;\n  }\n"
    ]);
    cash_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var cash_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-446f239d-0"
})(cash_styled_templateObject());
var SelectContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-446f239d-1"
})(cash_styled_templateObject1());
var cash_styled_InputStyled = (0,styled_components_browser_esm/* default */.ZP)(input/* default */.Z).withConfig({
    componentId: "sc-446f239d-2"
})(cash_styled_templateObject2(), function(props) {
    return props.isErrored && "\n    border-color: #EE4A49;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &:focus-within {\n      border-color: #EE4A49 !important;\n    }\n  ";
});
var cash_styled_InputError = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-446f239d-3"
})(cash_styled_templateObject3());
var BalanceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-446f239d-4"
})(cash_styled_templateObject4());
var BalanceButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-446f239d-5"
})(cash_styled_templateObject5());
var BalanceButtonLoader = (0,styled_components_browser_esm/* default */.ZP)(skeleton/* default.Input */.Z.Input).withConfig({
    componentId: "sc-446f239d-6"
})(cash_styled_templateObject6());
var cash_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-446f239d-7"
})(cash_styled_templateObject7());
var SwitchButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-446f239d-8"
})(cash_styled_templateObject8());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCash/index.tsx


















var TransferCash = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(null), amount = ref1[0], setAmount = ref1[1];
    var ref2 = (0,react.useState)(""), error = ref2[0], setError = ref2[1];
    var amountInputRef = (0,react.useRef)(null);
    var ref3 = usePortfolioSelect({
        visible: props.visible,
        form: form
    }), fromPortfolio = ref3.fromPortfolio, fromPortfolioOptions = ref3.fromPortfolioOptions, toPortfolio = ref3.toPortfolio, toPortfolioOptions = ref3.toPortfolioOptions, disabledSelect = ref3.disabledSelect, onChangeFromPortfolio = ref3.onChangeFromPortfolio, onChangeToPortfolio = ref3.onChangeToPortfolio, onSwitchPortfolio = ref3.onSwitchPortfolio, onReset = ref3.onReset;
    var setModal = (0,modal_store/* default */.Z)(function(s) {
        return s.openModal;
    });
    // cash transfer form
    var moveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.moveCashForm;
    });
    var setMoveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.setMoveCashForm;
    });
    // withdrawable balance
    var witdrawableLoading = (0,multiPorto/* default */.Z)(function(s) {
        return s.withDrawableData.isLoading;
    });
    var availableBalance = (0,multiPorto/* default */.Z)(function(s) {
        var ref, ref1;
        return ((ref = s.withDrawableData.data) === null || ref === void 0 ? void 0 : (ref1 = ref.balance) === null || ref1 === void 0 ? void 0 : ref1.net_withdrawable) || 0;
    });
    var getWithdrawableBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.getWithdrawable;
    });
    var resetWithdrawableBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetWithdrawable;
    });
    var disabledSubmit = (0,react.useMemo)(function() {
        return !amount || Number(amount) <= 0 || !!error || !fromPortfolio || !toPortfolio;
    }, [
        amount,
        error,
        fromPortfolio,
        toPortfolio
    ]);
    var formatInputNumber = function(value) {
        if (!value) return value;
        // Remove non-numeric characters (including '.' or ',') from the input
        var integerPart = value.replace(/\D/g, "");
        // Format the integer part with commas
        var formattedInteger = new Intl.NumberFormat("en-US").format(Number(integerPart));
        // Return the formatted integer without handling decimals
        return formattedInteger;
    };
    var handleChangeAmount = function(e) {
        var _target = e.target, value = _target.value, selectionStart = _target.selectionStart;
        var formattedValue = formatInputNumber(value);
        setAmount(formattedValue);
        var cursorPosition = selectionStart || 0;
        (0,utils/* adjustCursorPosition */._j)(e, cursorPosition, value, formattedValue);
        // Remove commas and convert to number for comparison
        var numericValue = parseFloat(value.replace(/,/g, ""));
        var exceedBalance = numericValue > availableBalance;
        var lessThanMinimum = numericValue < 50000;
        // Check if input exceeds available balance
        if (exceedBalance && !lessThanMinimum) {
            setError("Amount you entered exceeds the transferable balance");
        } else if (lessThanMinimum) {
            setError("Minimum transfer Rp50,000");
        } else {
            setError("");
        }
    };
    var handleReset = function() {
        onReset();
        setAmount("");
        setError("");
    };
    var handleSaveForm = function() {
        var ref, ref1;
        var unformattedAmount = amount.replace(/,/g, "");
        var numberAmount = parseFloat(unformattedAmount);
        setMoveCashForm({
            from_acc_no: fromPortfolio || "",
            from_acc_name: (ref = fromPortfolioOptions.find(function(subAccount) {
                return subAccount.value === fromPortfolio;
            })) === null || ref === void 0 ? void 0 : ref.label,
            to_acc_no: toPortfolio || "",
            to_acc_name: (ref1 = toPortfolioOptions.find(function(subAccount) {
                return subAccount.value === toPortfolio;
            })) === null || ref1 === void 0 ? void 0 : ref1.label,
            amount: Number.isNaN(numberAmount) ? 0 : numberAmount
        });
    };
    var handleSubmit = function() {
        onSubmit();
        handleSaveForm();
    };
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
        resetWithdrawableBalance();
    };
    var handleClickBalanceDetail = function() {
        if (!fromPortfolio) return;
        setModal(modal_store/* ModalNames.TRANSFER_CASH_BALANCE_REVIEW */.s.TRANSFER_CASH_BALANCE_REVIEW);
        handleSaveForm();
    };
    // Focus on amount input when fromPortfolio and toPortfolio are set
    (0,react.useEffect)(function() {
        if (fromPortfolio && toPortfolio) {
            var ref;
            (ref = amountInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        fromPortfolio,
        toPortfolio,
        amountInputRef
    ]);
    // Get withdrawable balance when fromPortfolio is set
    (0,react.useEffect)(function() {
        if (fromPortfolio) {
            getWithdrawableBalance(types/* BalanceScopeEnum.SELECTED_ACCOUNT */.k.SELECTED_ACCOUNT, fromPortfolio);
        }
    }, [
        fromPortfolio,
        getWithdrawableBalance
    ]);
    // Reset form when saved fromPortfolio is empty
    (0,react.useEffect)(function() {
        if (!moveCashForm.from_acc_no) handleReset();
    }, [
        moveCashForm.from_acc_no
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Transfer Cash",
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                layout: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchButton, {
                                onClick: function() {
                                    onSwitchPortfolio();
                                    setError("");
                                    setAmount("");
                                    form.resetFields([
                                        "amount"
                                    ]);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/multi-porto/transfer-switch.svg",
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferPortfolioSelect, {
                                label: "From Portfolio",
                                name: "fromPortfolio",
                                value: fromPortfolio,
                                options: fromPortfolioOptions,
                                onChange: function(value) {
                                    setError("");
                                    onChangeFromPortfolio(value);
                                },
                                disabled: disabledSelect,
                                id: "transfer-cash-source"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferPortfolioSelect, {
                                label: "To Portfolio",
                                name: "toPortfolio",
                                value: toPortfolio,
                                options: toPortfolioOptions,
                                onChange: function(value) {
                                    setError("");
                                    onChangeToPortfolio(value);
                                },
                                disabled: disabledSelect,
                                id: "transfer-cash-destination"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                        name: "amount",
                        label: "Input Amount",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_styled_InputStyled, {
                                ref: amountInputRef,
                                value: amount,
                                onChange: handleChangeAmount,
                                placeholder: "Input Amount",
                                prefix: "Rp",
                                type: "text",
                                isErrored: !!error
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_styled_InputError, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/alert/warning.svg",
                                        alt: "Error"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: error
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Transferable Balance (Settled)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: witdrawableLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceButtonLoader, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !witdrawableLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceButton, {
                                            onClick: handleClickBalanceDetail,
                                            className: fromPortfolio ? "clickable" : "",
                                            children: [
                                                (0,utils/* formatCurrency */.xG)(String((0,securities_utils/* getRoundDownValue */.kk)(fromPortfolio ? availableBalance : 0, 0))),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                    condition: !!fromPortfolio,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: "/icon/chevron-right-gray.svg",
                                                        alt: ""
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_styled_NextButton, {
                            type: "primary",
                            disabled: disabledSubmit,
                            onClick: handleSubmit,
                            children: "Continue"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var Transfer_TransferCash = (TransferCash);

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCashConfirm/cash-cofirm.styled.ts

function cash_cofirm_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 20px 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    cash_cofirm_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 20px;\n"
    ]);
    cash_cofirm_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 16px;\n  line-height: 22px;\n  gap: 4px;\n\n  span {\n    font-weight: 700;\n  }\n"
    ]);
    cash_cofirm_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #EDEDED;\n  border-radius: 4px;\n  width: 100%;\n"
    ]);
    cash_cofirm_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  flex: 1;\n"
    ]);
    cash_cofirm_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    cash_cofirm_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n  margin: 0;\n  color: #858585;\n"
    ]);
    cash_cofirm_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function cash_cofirm_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n"
    ]);
    cash_cofirm_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var cash_cofirm_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aede67f7-0"
})(cash_cofirm_styled_templateObject());
var ConfirmInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aede67f7-1"
})(cash_cofirm_styled_templateObject1());
var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aede67f7-2"
})(cash_cofirm_styled_templateObject2());
var PortfolioContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aede67f7-3"
})(cash_cofirm_styled_templateObject3());
var PortfolioInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aede67f7-4"
})(cash_cofirm_styled_templateObject4());
var PortfolioName = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-aede67f7-5"
})(cash_cofirm_styled_templateObject5());
var PortfolioInfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-aede67f7-6"
})(cash_cofirm_styled_templateObject6());
var cash_cofirm_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-aede67f7-7"
})(cash_cofirm_styled_templateObject7());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCashConfirm/index.tsx















function TransferCashConfirm(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, onBack = _param.onBack, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit",
        "onBack"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var moveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.moveCashForm;
    });
    var postMoveCash = (0,multiPorto/* default */.Z)(function(s) {
        return s.postMoveCash;
    });
    var resetMoveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetMoveCashForm;
    });
    var resetWithdrawableBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetWithdrawable;
    });
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var payload, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        payload = (0,_object_spread/* default */.Z)({}, moveCashForm);
                        delete payload.from_acc_name;
                        delete payload.to_acc_name;
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return postMoveCash(payload);
                    case 7:
                        result = _ctx.sent;
                        if (typeof result === "boolean" && result) {
                            onSubmit();
                        }
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        ;
                    case 14:
                        setLoading(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function(e) {
        onCancel(e);
        resetMoveCashForm();
        resetWithdrawableBalance();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            style: {
                cursor: "pointer"
            },
            src: "/icon/chevron/left.svg",
            alt: "",
            onClick: onBack
        }),
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default */.Z, {
            form: form,
            layout: "vertical",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_cofirm_styled_Container, {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConfirmInfoContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/multi-porto/saldo-rdn.svg",
                                alt: "",
                                width: 56,
                                height: 56
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                                children: [
                                    "Transfer Cash",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: (0,utils/* formatCurrency */.xG)(String((0,securities_utils/* getRoundDownValue */.kk)(moveCashForm.amount, 2)))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PortfolioContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PortfolioInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioName, {
                                                children: moveCashForm.from_acc_name || ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioInfoText, {
                                                children: "Source Portfolio"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/chevron/right-double-primary.svg",
                                        alt: "",
                                        width: 16,
                                        height: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PortfolioInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioName, {
                                                children: moveCashForm.to_acc_name || ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioInfoText, {
                                                children: "Destination Portfolio"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_cofirm_styled_NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            disabled: loading,
                            loading: loading,
                            children: "Confirm"
                        })
                    })
                ]
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCashSuccess/cash-success.styled.ts

function cash_success_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  img {\n    width: 160px;\n    height: 120px;\n    align-self: center;\n  }\n"
    ]);
    cash_success_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cash_success_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n"
    ]);
    cash_success_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cash_success_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 400;\n  font-family: ProximaNovaRg;\n"
    ]);
    cash_success_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cash_success_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n"
    ]);
    cash_success_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cash_success_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 27px;\n  margin: 0;\n  color: #00AB6B;\n"
    ]);
    cash_success_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function cash_success_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 160px;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n  align-self: center;\n"
    ]);
    cash_success_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var cash_success_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de984cf-0"
})(cash_success_styled_templateObject());
var cash_success_styled_ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de984cf-1"
})(cash_success_styled_templateObject1());
var CashTransferTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-5de984cf-2"
})(cash_success_styled_templateObject2());
var CashTransferSuccess = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5de984cf-3"
})(cash_success_styled_templateObject3());
var CashTransfered = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-5de984cf-4"
})(cash_success_styled_templateObject4());
var cash_success_styled_FinishButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-5de984cf-5"
})(cash_success_styled_templateObject5());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCashSuccess/index.tsx











var TransferCashSuccess = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var router = (0,next_router.useRouter)();
    var moveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.moveCashForm;
    });
    var resetMoveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetMoveCashForm;
    });
    var resetWithdrawableBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetWithdrawable;
    });
    var handleReset = function() {
        resetMoveCashForm();
        resetWithdrawableBalance();
        router.push("/securities/history");
    };
    var handleSubmit = function() {
        onSubmit();
        handleReset();
    };
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_success_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/multi-porto/success-transfer-cash.svg",
                    alt: ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_success_styled_ContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CashTransferTitle, {
                            children: "Cash Transfer Successful"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CashTransfered, {
                            children: (0,utils/* formatCurrency */.xG)(String((0,securities_utils/* getRoundDownValue */.kk)(moveCashForm.amount, 2)))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(cash_success_styled_FinishButton, {
                    onClick: handleSubmit,
                    type: "primary",
                    children: "Close"
                })
            ]
        })
    }));
};
/* harmony default export */ var Transfer_TransferCashSuccess = (TransferCashSuccess);

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCashBalanceReview/cash-review.styled.tsx

function cash_review_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 8px;\n"
    ]);
    cash_review_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0 20px 20px;\n  display: flex;\n  flex-direction: column;\n\n  .ant-divider-horizontal {\n    margin: 0;\n  }\n\n  .content-divider {\n    height: 8px;\n    margin-left: -20px;\n    width: calc(100% + 40px);\n    background: #ededed;\n    border: none;\n  }\n"
    ]);
    cash_review_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-bottom: 20px;\n"
    ]);
    cash_review_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n\n  h1,\n  h6 {\n    margin: 0;\n    color: #333333;\n  }\n\n  h1 {\n    font-size: 14px;\n    line-height: 19px;\n  }\n\n  h6 {\n    font-size: 20px;\n    line-height: 27px;\n  }\n"
    ]);
    cash_review_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    cash_review_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  gap: 4px;\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    line-height: 19px;\n    color: #333333;\n  }\n\n  p.negative {\n    color: #ee4a49;\n  }\n\n  &.bold {\n    font-weight: bold;\n  }\n"
    ]);
    cash_review_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 6px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  padding: 12px;\n"
    ]);
    cash_review_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n\n  p {\n    margin: 0;\n    color: #333333;\n  }\n\n  p.bold {\n    font-weight: bold;\n  }\n\n  p.date {\n    color: #858585;\n    margin-bottom: 6px;\n  }\n"
    ]);
    cash_review_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function cash_review_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-top: 20px;\n\n  p {\n    margin: 0;\n    color: #333333;\n    font-size: 14px;\n    line-height: 19px;\n  }\n"
    ]);
    cash_review_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var cash_review_styled_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-0"
})(cash_review_styled_templateObject());
var cash_review_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-1"
})(cash_review_styled_templateObject1());
var InfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-2"
})(cash_review_styled_templateObject2());
var InfoTitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-3"
})(cash_review_styled_templateObject3());
var cash_review_styled_BalanceContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-4"
})(cash_review_styled_templateObject4());
var BalanceItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-5"
})(cash_review_styled_templateObject5());
var BalanceSettlementContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-6"
})(cash_review_styled_templateObject6());
var BalanceSettlementItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-7"
})(cash_review_styled_templateObject7());
var LegendsContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-747f7979-8"
})(cash_review_styled_templateObject8());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferCashBalanceReview/index.tsx













function TransferCashBalanceReview(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, onBack = _param.onBack, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onBack"
    ]);
    var witdrawableData = (0,multiPorto/* default */.Z)(function(s) {
        return s.withDrawableData.data;
    });
    var resetMoveCashForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetMoveCashForm;
    });
    var resetWithdrawableBalance = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetWithdrawable;
    });
    var _balance = witdrawableData.balance, withdrawable = _balance.withdrawable, transaction = _balance.transaction, pending = _balance.pending, leverage_liability = _balance.leverage_liability, net_withdrawable = _balance.net_withdrawable;
    var _settlement_schedules = witdrawableData.settlement_schedules, settlement_schedules = _settlement_schedules === void 0 ? [] : _settlement_schedules;
    var _legends = witdrawableData.legends, legends = _legends === void 0 ? [] : _legends;
    var handleCancel = function(e) {
        onCancel(e);
        resetMoveCashForm();
        resetWithdrawableBalance();
    };
    var getFormattedCurrency = function(value) {
        return (0,utils/* formatCurrency */.xG)(String((0,securities_utils/* getRoundDownValue */.kk)(value, 0)));
    };
    var getShiftedCurrency = function(value) {
        return (0,utils/* formatShiftedCurrency */.C2)((0,securities_utils/* getRoundDownValue */.kk)(value, 0));
    };
    if (!witdrawableData) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_review_styled_Title, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    style: {
                        cursor: "pointer"
                    },
                    src: "/icon/chevron/left.svg",
                    alt: "",
                    onClick: onBack
                }),
                "Transfer Cash"
            ]
        }),
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_review_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoTitleContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    children: "Saldo Dapat Ditranser"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    children: getFormattedCurrency(withdrawable)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(cash_review_styled_BalanceContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceItem, {
                                    children: [
                                        "Saldo Transaksi",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: getShiftedCurrency(transaction)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceItem, {
                                    children: [
                                        "Saldo Tertunda",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "negative",
                                            children: getShiftedCurrency(pending)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceItem, {
                                    children: [
                                        "Kewajiban Leverage",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "negative",
                                            children: getShiftedCurrency(leverage_liability)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceItem, {
                                    className: "bold",
                                    children: [
                                        "Saldo Dapat Ditransfer (T+0)",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: getShiftedCurrency(net_withdrawable)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BalanceSettlementContainer, {
                                    children: settlement_schedules.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BalanceSettlementItem, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "bold",
                                                    children: item.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "date",
                                                    children: item.formatted_date
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: (0,utils/* formatPrice */.T4)(String((0,securities_utils/* getRoundDownValue */.kk)(item.balance, 0)))
                                                })
                                            ]
                                        }, item.title);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {
                    className: "content-divider"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LegendsContainer, {
                    children: legends.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: (0,html_react_parser/* default */.ZP)(sanitize_html_default()(item) || "")
                        }, "content-item-".concat(item.slice(0, 10)));
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/utils/securities/formatter.ts
var formatter = __webpack_require__(89237);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/CompanyLogo/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #3a645c;\n  border-radius: 50%;\n  color: #ffffff;\n  display: flex;\n  height: ",
        "px;\n  width: ",
        "px;\n\n  > small {\n    font-family: 'Proxima Nova', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n    margin: auto;\n    text-align: center;\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ImagePlaceholder = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-a4cc714f-0"
})(styled_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
});

;// CONCATENATED MODULE: ./src/features/multi-porto/components/CompanyLogo/index.tsx




var CompanyIcon = function(param) {
    var symbol = param.symbol, avatar_url = param.avatar_url, _size = param.size, size = _size === void 0 ? 20 : _size;
    var ref = (0,react.useState)(true), isIconAvailable = ref[0], setIsIconAvailable = ref[1];
    if (isIconAvailable) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            src: avatar_url,
            alt: "",
            width: size,
            height: size,
            onError: function() {
                return setIsIconAvailable(false);
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {
        size: size,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
            children: !!symbol && symbol.toUpperCase().slice(0, 1)
        })
    });
};
/* harmony default export */ var CompanyLogo = (CompanyIcon);

// EXTERNAL MODULE: ./src/global/Securities/components/InputStepper/index.tsx + 1 modules
var InputStepper = __webpack_require__(97077);
;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferStock/stock.styled.ts

function stock_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px 20px;\n\n  .ant-form-item-label {\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 19px;\n  }\n\n  .ant-input-prefix {\n    margin-right: 0;\n  }\n\n  .ant-select {\n    cursor: default;\n  }\n\n  .ant-select-selector {\n    cursor: pointer;\n  }\n"
    ]);
    stock_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function stock_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 8px;\n  max-height: calc(100vh - 370px);\n  overflow-y: auto;\n\n  /* Hide scrollbar for Chrome, Safari and Opera */\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Hide scrollbar for IE, Edge and Firefox */\n  -ms-overflow-style: none;  /* IE and Edge */\n"
    ]);
    stock_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function stock_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #EDEDED;\n  border-radius: 4px;\n  margin-bottom: 24px;\n  position: relative;\n\n  .ant-form-item {\n    margin-bottom: 0;\n    padding-top: 10px;\n  }\n\n  .ant-form-item:first-child {\n    padding-bottom: 1px;\n  }\n\n  .ant-form-item:last-child {\n    border-top: 1px solid #EDEDED;\n  }\n\n  .ant-form-item-label {\n    padding: 0;\n    padding-left: 12px;\n  }\n\n  .ant-form-item-label > label {\n    font-size: 13px;\n    line-height: 18px;\n    font-weight: 400;\n    color: #858585 !important;\n  }\n\n  .ant-select-selector {\n    border: none !important;\n  }\n\n  .ant-select-selection-item {\n    color: #333333 !important;\n    font-weight: 700;\n  }\n\n  .ant-form-item .ant-select {\n    display: flex;\n    align-items: center;\n  }\n\n  .ant-select .ant-select-selector {\n    width: unset !important;\n  }\n\n  .ant-select-arrow {\n    position: relative;\n    margin-left: -10px;\n  }\n"
    ]);
    stock_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function stock_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 24px;\n"
    ]);
    stock_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function stock_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n"
    ]);
    stock_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function stock_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  cursor: pointer;\n  color: #333333;\n  background: #ffffff;\n  font-size: 14px;\n  line-height: 19px;\n  border: 1px solid #EDEDED;\n  border-radius: 50px;\n  width: 28px;\n  height: 28px;\n\n  position: absolute;\n  right: 16px;\n  top: 47px;\n  z-index: 1;\n\n  img {\n    cursor: pointer;\n  }\n"
    ]);
    stock_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function stock_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n\n  h1, p {\n    margin: 0;\n    font-size: 13px;\n    line-height: 18px;\n  }\n\n  h1 {\n    font-weight: 700;\n    color: #333333;\n  }\n\n  p {\n    color: #858585;\n  }\n"
    ]);
    stock_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function stock_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  min-height: 180px;\n\n  .ant-skeleton-input {\n    border-radius: 4px;\n  }\n"
    ]);
    stock_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function stock_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  padding: 20px 0;\n  gap: 20px;\n"
    ]);
    stock_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  text-align: center;\n\n  h1, p {\n    margin: 0;\n  }\n\n  h1 {\n    font-size: 14px;\n    line-height: 19px;\n    font-weight: 700;\n    color: #333333;\n  }\n\n  p {\n    font-size: 13px;\n    line-height: 18px;\n    color: #858585;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 0;\n  border-bottom: 1px solid #EDEDED;\n  gap: 8px;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  flex: 1;\n  gap: 8px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n\n  h1, p {\n    margin: 0;\n  }\n\n  h1 {\n    font-size: 14px;\n    line-height: 19px;\n    font-weight: 700;\n    color: #333333;\n  }\n\n  p {\n    font-size: 13px;\n    line-height: 18px;\n    color: #858585;\n\n    span {\n      color: #333333;\n    }\n  }\n\n  .ant-skeleton {\n    height: 13px;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  min-width: 140px;\n  flex: 0;\n\n  .input-stepper-container {\n    border: 1px solid #ededed;\n    border-radius: 4px;\n\n    &.active {\n      border: 1px solid #00AB6B;\n    }\n\n    input {\n      border: none;\n    }\n\n    button {\n      background: #ffffff;\n      border: none;\n\n      :hover {\n        background: #ededed;\n      }\n    }\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var stock_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-0"
})(stock_styled_templateObject());
var ScrollableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-1"
})(stock_styled_templateObject1());
var stock_styled_SelectContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-2"
})(stock_styled_templateObject2());
var ButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-3"
})(stock_styled_templateObject3());
var stock_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-45e4c90e-4"
})(stock_styled_templateObject4());
var stock_styled_SwitchButton = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-5"
})(stock_styled_templateObject5());
var SectionTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-6"
})(stock_styled_templateObject6());
var StockListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-7"
})(stock_styled_templateObject7());
var EmptyContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-8"
})(stock_styled_templateObject8());
var EmptyText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-9"
})(_templateObject9());
var StockItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-10"
})(_templateObject10());
var StockItemInfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-11"
})(_templateObject11());
var StockItemInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-12"
})(_templateObject12());
var StockItemInputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-45e4c90e-13"
})(_templateObject13());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferStock/index.tsx



















var TransferStock = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref[0];
    var ref1 = (0,react.useState)({}), stocks = ref1[0], setStocks = ref1[1];
    var ref2 = usePortfolioSelect({
        visible: props.visible,
        form: form
    }), fromPortfolio = ref2.fromPortfolio, fromPortfolioOptions = ref2.fromPortfolioOptions, toPortfolio = ref2.toPortfolio, toPortfolioOptions = ref2.toPortfolioOptions, disabledSelect = ref2.disabledSelect, onChangeFromPortfolio = ref2.onChangeFromPortfolio, onChangeToPortfolio = ref2.onChangeToPortfolio, onSwitchPortfolio = ref2.onSwitchPortfolio, onReset = ref2.onReset;
    var subAccountsLoading = (0,multiPorto/* default */.Z)(function(s) {
        return s.subAccountsData.isLoading;
    });
    // stock transfer form
    var moveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.moveStockForm;
    });
    var setMoveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.setMoveStockForm;
    });
    var resetMoveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetMoveStockForm;
    });
    // transferable stocks
    var transferableLoading = (0,multiPorto/* default */.Z)(function(s) {
        return s.transferableStocks.isLoading;
    });
    var transferableStocksLists = (0,multiPorto/* default */.Z)(function(s) {
        return s.transferableStocks.data.stocks;
    });
    var getTransferableStocks = (0,multiPorto/* default */.Z)(function(s) {
        return s.getTransferableStocks;
    });
    var resetTransferableStocks = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetTransferableStocks;
    });
    var transferableStocksList = (0,react.useMemo)(function() {
        return transferableStocksLists.filter(function(stock) {
            return Number(stock.transferable_shares_qty) >= 100;
        }) || [];
    }, [
        transferableStocksLists
    ]);
    var disabledSubmit = (0,react.useMemo)(function() {
        var filledShares = Object.values(stocks).some(function(stock) {
            return stock.shares > 0;
        });
        return !fromPortfolio || !toPortfolio || !filledShares;
    }, [
        fromPortfolio,
        toPortfolio,
        stocks
    ]);
    var showEmptyList = (0,react.useMemo)(function() {
        return !transferableStocksList.length || !fromPortfolio;
    }, [
        transferableStocksList,
        fromPortfolio
    ]);
    var showShimmer = (0,react.useMemo)(function() {
        return transferableLoading || subAccountsLoading && !moveStockForm.from_acc_no;
    }, [
        transferableLoading,
        subAccountsLoading,
        moveStockForm.from_acc_no
    ]);
    var handleResetStockFields = function() {
        // Get all field names
        var allFields = form.getFieldsValue();
        // Filter out field names starting with `stock-`
        var stockFieldNames = Object.keys(allFields).filter(function(fieldName) {
            return fieldName.startsWith("stock-");
        });
        // Reset only those fields
        form.resetFields(stockFieldNames);
    };
    var handleLotChange = function(value, symbol) {
        setStocks((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stocks), (0,_define_property/* default */.Z)({}, symbol, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, stocks[symbol]), {
            shares: value * constant/* lotSize */.CQ
        }))));
    };
    var handleReset = function() {
        onReset();
        setStocks({});
        resetTransferableStocks();
    };
    var handleSaveForm = function() {
        var ref, ref1;
        setMoveStockForm({
            from_acc_no: fromPortfolio || "",
            from_acc_name: (ref = fromPortfolioOptions.find(function(subAccount) {
                return subAccount.value === fromPortfolio;
            })) === null || ref === void 0 ? void 0 : ref.label,
            to_acc_no: toPortfolio || "",
            to_acc_name: (ref1 = toPortfolioOptions.find(function(subAccount) {
                return subAccount.value === toPortfolio;
            })) === null || ref1 === void 0 ? void 0 : ref1.label,
            stocks_data: Object.values(stocks).filter(function(stock) {
                return stock.shares > 0;
            })
        });
    };
    var handleSubmit = function() {
        onSubmit();
        handleSaveForm();
    };
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
        resetMoveStockForm();
    };
    // Set initial value for stocks
    (0,react.useEffect)(function() {
        setStocks(transferableStocksList.reduce(function(acc, stock) {
            // eslint-disable-next-line no-param-reassign
            acc[stock.stock_code] = {
                stock_code: stock.stock_code,
                shares: 0,
                avatar_url: stock.stock_icon_url || ""
            };
            return acc;
        }, {}));
    }, [
        transferableStocksList
    ]);
    // Get transferable stocks when fromPortfolio is set
    (0,react.useEffect)(function() {
        if (fromPortfolio) {
            getTransferableStocks(fromPortfolio);
            handleResetStockFields();
        }
    }, [
        fromPortfolio,
        getTransferableStocks
    ]);
    // Reset form when saved fromPortfolio is empty
    (0,react.useEffect)(function() {
        if (!moveStockForm.from_acc_no) handleReset();
    }, [
        moveStockForm.from_acc_no
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Transfer Stock",
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
                form: form,
                layout: "vertical",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollableContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_styled_SelectContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_styled_SwitchButton, {
                                        onClick: onSwitchPortfolio,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/multi-porto/transfer-switch.svg",
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferPortfolioSelect, {
                                        label: "From Portfolio",
                                        name: "fromPortfolio",
                                        value: fromPortfolio,
                                        options: fromPortfolioOptions,
                                        onChange: onChangeFromPortfolio,
                                        disabled: disabledSelect,
                                        id: "transfer-stock-source"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferPortfolioSelect, {
                                        label: "To Portfolio",
                                        name: "toPortfolio",
                                        value: toPortfolio,
                                        options: toPortfolioOptions,
                                        onChange: onChangeToPortfolio,
                                        disabled: disabledSelect,
                                        id: "transfer-stock-destination"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SectionTitle, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Select Stocks"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "You can select stocks that have been settled (T+2)."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockListContainer, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                    condition: showShimmer,
                                    children: [
                                        Array.from({
                                            length: 2
                                        }).map(function(_, idx) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockItem, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockItemInfoWrapper, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Avatar */.Z.Avatar, {
                                                                active: true,
                                                                size: 32,
                                                                shape: "circle"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockItemInfo, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                                                        style: {
                                                                            width: 50,
                                                                            height: 13
                                                                        },
                                                                        active: true
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                                                        style: {
                                                                            width: 100,
                                                                            height: 13
                                                                        },
                                                                        active: true
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StockItemInputWrapper, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default.Input */.Z.Input, {
                                                            style: {
                                                                width: 140,
                                                                height: 32
                                                            },
                                                            active: true
                                                        })
                                                    })
                                                ]
                                            }, "empty-row-".concat(idx.toString()));
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default.Else */.Z.Else, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                    condition: showEmptyList,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyContainer, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                                src: "/images/multi-porto/empty-stock.svg",
                                                                alt: "",
                                                                width: 100,
                                                                height: 75
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmptyText, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                        children: "Your Portfolio is Empty"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        children: "You can transfer your stocks to this portfolio and start investing."
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                    condition: !showEmptyList,
                                                    children: transferableStocksList === null || transferableStocksList === void 0 ? void 0 : transferableStocksList.map(function(stock) {
                                                        var stock_code = stock.stock_code, transferable_shares_qty = stock.transferable_shares_qty, stock_icon_url = stock.stock_icon_url;
                                                        var totalLot = Math.floor(Number(transferable_shares_qty) / constant/* lotSize */.CQ);
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockItem, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockItemInfoWrapper, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo, {
                                                                            symbol: stock.stock_code,
                                                                            avatar_url: stock_icon_url,
                                                                            size: 32
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockItemInfo, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                                                    children: stock_code
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    children: [
                                                                                        "Available Lot:",
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                            children: [
                                                                                                (0,formatter/* lotFormatter */.TQ)(totalLot),
                                                                                                " Lot"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StockItemInputWrapper, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                                                        name: "stock-".concat(stock.stock_code),
                                                                        label: "",
                                                                        style: {
                                                                            marginBottom: 0
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputStepper/* default */.Z, {
                                                                            min: 0,
                                                                            max: totalLot,
                                                                            disableDecimal: true,
                                                                            onChange: function(val) {
                                                                                return handleLotChange(val, stock_code);
                                                                            },
                                                                            containerClassName: "input-stepper-container"
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        }, stock.stock_code);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                            style: {
                                margin: "0px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_styled_NextButton, {
                                onClick: handleSubmit,
                                type: "primary",
                                disabled: disabledSubmit,
                                children: "Continue"
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var Transfer_TransferStock = (TransferStock);

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferStockConfirm/stock-confirm.styled.ts

function stock_confirm_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 0 20px 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    stock_confirm_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 20px;\n"
    ]);
    stock_confirm_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  gap: 16px;\n  border: 1px solid #EDEDED;\n  border-radius: 4px;\n  padding: 16px;\n\n  max-height: calc(100vh - 465px);\n  overflow-y: auto;\n"
    ]);
    stock_confirm_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  width: 100%;\n  gap: 10px;\n"
    ]);
    stock_confirm_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 700;\n  margin: 0;\n  flex: 1;\n"
    ]);
    stock_confirm_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    stock_confirm_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #EDEDED;\n  border-radius: 4px;\n  width: 100%;\n"
    ]);
    stock_confirm_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: center;\n  flex: 1;\n"
    ]);
    stock_confirm_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    stock_confirm_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 12px;\n  line-height: 16px;\n  font-weight: 400;\n  margin: 0;\n  color: #858585;\n"
    ]);
    stock_confirm_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function stock_confirm_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n"
    ]);
    stock_confirm_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var stock_confirm_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be975551-0"
})(stock_confirm_styled_templateObject());
var stock_confirm_styled_ConfirmInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be975551-1"
})(stock_confirm_styled_templateObject1());
var stock_confirm_styled_StockListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be975551-2"
})(stock_confirm_styled_templateObject2());
var stock_confirm_styled_StockItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be975551-3"
})(stock_confirm_styled_templateObject3());
var StockName = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-be975551-4"
})(stock_confirm_styled_templateObject4());
var StockLot = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-be975551-5"
})(stock_confirm_styled_templateObject5());
var stock_confirm_styled_PortfolioContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be975551-6"
})(stock_confirm_styled_templateObject6());
var stock_confirm_styled_PortfolioInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-be975551-7"
})(stock_confirm_styled_templateObject7());
var stock_confirm_styled_PortfolioName = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-be975551-8"
})(stock_confirm_styled_templateObject8());
var stock_confirm_styled_PortfolioInfoText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-be975551-9"
})(stock_confirm_styled_templateObject9());
var stock_confirm_styled_NextButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-be975551-10"
})(stock_confirm_styled_templateObject10());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferStockConfirm/index.tsx
















function TransferStockConfirm(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var ref2 = (0,react.useState)(false), loading = ref2[0], setLoading = ref2[1];
    var moveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.moveStockForm;
    });
    var postMoveStock = (0,multiPorto/* default */.Z)(function(s) {
        return s.postMoveStock;
    });
    var resetMoveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetMoveStockForm;
    });
    var handleReset = function() {
        resetMoveStockForm();
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, payload, result;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setLoading(true);
                        payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, moveStockForm), {
                            stocks_data: (ref = moveStockForm.stocks_data) === null || ref === void 0 ? void 0 : ref.map(function(stock) {
                                return {
                                    stock_code: stock.stock_code,
                                    shares: stock.shares
                                };
                            })
                        });
                        delete payload.from_acc_name;
                        delete payload.to_acc_name;
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return postMoveStock(payload);
                    case 8:
                        result = _ctx.sent;
                        if (typeof result === "boolean" && result) {
                            onSubmit();
                        }
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        ;
                    case 15:
                        setLoading(false);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Transfer Stock",
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default */.Z, {
            form: form,
            layout: "vertical",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_confirm_styled_Container, {
                onClick: function(e) {
                    return e.stopPropagation();
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_confirm_styled_ConfirmInfoContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_confirm_styled_StockListContainer, {
                                children: (ref = moveStockForm.stocks_data) === null || ref === void 0 ? void 0 : ref.map(function(stock) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_confirm_styled_StockItem, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo, {
                                                symbol: stock.stock_code,
                                                avatar_url: stock.avatar_url,
                                                size: 20
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StockName, {
                                                children: stock.stock_code
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StockLot, {
                                                children: [
                                                    (0,formatter/* lotFormatter */.TQ)(stock.shares / constant/* lotSize */.CQ),
                                                    " Lot"
                                                ]
                                            })
                                        ]
                                    }, stock.stock_code);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_confirm_styled_PortfolioContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_confirm_styled_PortfolioInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_confirm_styled_PortfolioName, {
                                                children: moveStockForm.from_acc_name || ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_confirm_styled_PortfolioInfoText, {
                                                children: "Source Portfolio"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: "/icon/chevron/right-double-primary.svg",
                                        alt: "",
                                        width: 16,
                                        height: 16
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_confirm_styled_PortfolioInfo, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_confirm_styled_PortfolioName, {
                                                children: moveStockForm.to_acc_name || ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_confirm_styled_PortfolioInfoText, {
                                                children: "Destination Portfolio"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                        style: {
                            marginBottom: 0
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_confirm_styled_NextButton, {
                            onClick: handleSubmit,
                            type: "primary",
                            disabled: loading,
                            loading: loading,
                            children: "Confirm"
                        })
                    })
                ]
            })
        })
    }));
};

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferStockSuccess/stock-success.styled.ts

function stock_success_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  > img {\n    align-self: center;\n  }\n"
    ]);
    stock_success_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  gap: 4px;\n"
    ]);
    stock_success_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: 700;\n"
    ]);
    stock_success_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 160px;\n  height: 44px;\n  border-radius: 4px;\n  font-family: ProximaNovaRg;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n  cursor: pointer;\n  align-self: center;\n"
    ]);
    stock_success_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  align-items: center;\n  gap: 16px;\n  border: 1px solid #EDEDED;\n  border-radius: 4px;\n  padding: 16px;\n\n  max-height: calc(100vh - 490px);\n  overflow-y: auto;\n"
    ]);
    stock_success_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n  width: 100%;\n  gap: 10px;\n"
    ]);
    stock_success_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  line-height: 19px;\n  font-weight: 700;\n  margin: 0;\n  flex: 1;\n"
    ]);
    stock_success_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function stock_success_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 700;\n  margin: 0;\n"
    ]);
    stock_success_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var stock_success_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2400c620-0"
})(stock_success_styled_templateObject());
var stock_success_styled_ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2400c620-1"
})(stock_success_styled_templateObject1());
var StockTransferTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-2400c620-2"
})(stock_success_styled_templateObject2());
var stock_success_styled_FinishButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-2400c620-3"
})(stock_success_styled_templateObject3());
var stock_success_styled_StockListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2400c620-4"
})(stock_success_styled_templateObject4());
var stock_success_styled_StockItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2400c620-5"
})(stock_success_styled_templateObject5());
var stock_success_styled_StockName = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-2400c620-6"
})(stock_success_styled_templateObject6());
var stock_success_styled_StockLot = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-2400c620-7"
})(stock_success_styled_templateObject7());

;// CONCATENATED MODULE: ./src/features/multi-porto/components/Modal/Transfer/TransferStockSuccess/index.tsx












var TransferStockSuccess = function(_param) {
    var _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, _onSubmit = _param.onSubmit, onSubmit = _onSubmit === void 0 ? function() {} : _onSubmit, props = (0,_object_without_properties/* default */.Z)(_param, [
        "onCancel",
        "onSubmit"
    ]);
    var ref;
    var router = (0,next_router.useRouter)();
    var moveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.moveStockForm;
    });
    var resetMoveStockForm = (0,multiPorto/* default */.Z)(function(s) {
        return s.resetMoveStockForm;
    });
    var handleReset = function() {
        resetMoveStockForm();
        router.push("/securities/history");
    };
    var handleSubmit = function() {
        onSubmit();
        handleReset();
    };
    var handleCancel = function(e) {
        onCancel(e);
        handleReset();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        hideSubmit: true,
        onCancel: handleCancel,
        className: "modal-multi-porto",
        transitionName: ""
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_success_styled_Container, {
            onClick: function(e) {
                return e.stopPropagation();
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/multi-porto/success-transfer-stock.svg",
                    alt: "",
                    height: 80,
                    width: 80
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_success_styled_ContentWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StockTransferTitle, {
                        children: "Stock Transferred"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_success_styled_StockListContainer, {
                    children: (ref = moveStockForm.stocks_data) === null || ref === void 0 ? void 0 : ref.map(function(stock) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_success_styled_StockItem, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo, {
                                    symbol: stock.stock_code,
                                    avatar_url: stock.avatar_url,
                                    size: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_success_styled_StockName, {
                                    children: stock.stock_code
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(stock_success_styled_StockLot, {
                                    children: [
                                        (0,formatter/* lotFormatter */.TQ)(stock.shares / constant/* lotSize */.CQ),
                                        " Lot"
                                    ]
                                })
                            ]
                        }, stock.stock_code);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stock_success_styled_FinishButton, {
                    onClick: handleSubmit,
                    type: "primary",
                    children: "Close"
                })
            ]
        })
    }));
};
/* harmony default export */ var Transfer_TransferStockSuccess = (TransferStockSuccess);

;// CONCATENATED MODULE: ./src/features/multi-porto/components/ModalManager/index.tsx




















function MultiPortoModalManager() {
    var modal = (0,modal_store/* default */.Z)(function(s) {
        return s.activeModal;
    });
    var setModal = (0,modal_store/* default */.Z)(function(s) {
        return s.openModal;
    });
    var closeModal = (0,modal_store/* default */.Z)(function(s) {
        return s.closeModal;
    });
    var getSubAccounts = (0,useSubAccounts/* default */.Z)().getSubAccounts;
    var onCreatePortfolio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, canCreatePortfolio;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        closeModal();
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return getSubAccounts();
                    case 4:
                        data = _ctx.sent;
                        canCreatePortfolio = data.can_create_new_sub_account;
                        if (canCreatePortfolio) {
                            _ctx.next = 9;
                            break;
                        }
                        setModal(modal_store/* ModalNames.PORTFOLIO_CREATE_BLOCKED */.s.PORTFOLIO_CREATE_BLOCKED);
                        return _ctx.abrupt("return");
                    case 9:
                        setModal(modal_store/* ModalNames.PORTFOLIO_CREATE */.s.PORTFOLIO_CREATE);
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    12
                ]
            ]);
        }));
        return function onCreatePortfolio() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (modal) {
            document.body.classList.add("modal-multi-porto-open");
        } else {
            document.body.classList.remove("modal-multi-porto-open");
        }
        return function() {
            document.body.classList.remove("modal-multi-porto-open");
        };
    }, [
        modal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateOnboarding, {
                visible: modal === modal_store/* ModalNames.PORTFOLIO_ONBOARDING */.s.PORTFOLIO_ONBOARDING,
                onCancel: closeModal,
                onSubmit: onCreatePortfolio
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreatePorto, {
                visible: modal === modal_store/* ModalNames.PORTFOLIO_CREATE */.s.PORTFOLIO_CREATE,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.PORTFOLIO_TNC */.s.PORTFOLIO_TNC);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateRenamePorto, {
                visible: modal === modal_store/* ModalNames.PORTFOLIO_RENAME */.s.PORTFOLIO_RENAME,
                onCancel: closeModal,
                onSubmit: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateTnc, {
                visible: modal === modal_store/* ModalNames.PORTFOLIO_TNC */.s.PORTFOLIO_TNC,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.PORTFOLIO_SUCCESS */.s.PORTFOLIO_SUCCESS);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateSuccess, {
                visible: modal === modal_store/* ModalNames.PORTFOLIO_SUCCESS */.s.PORTFOLIO_SUCCESS,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CreateError, {
                visible: modal === modal_store/* ModalNames.PORTFOLIO_CREATE_BLOCKED */.s.PORTFOLIO_CREATE_BLOCKED,
                onCancel: closeModal,
                onSubmit: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferSelect, {
                visible: modal === modal_store/* ModalNames.TRANSFER_SELECT */.s.TRANSFER_SELECT,
                onCancel: closeModal,
                onSubmit: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transfer_TransferCash, {
                visible: modal === modal_store/* ModalNames.TRANSFER_CASH */.s.TRANSFER_CASH,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.TRANSFER_CASH_CONFIRM */.s.TRANSFER_CASH_CONFIRM);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferCashConfirm, {
                visible: modal === modal_store/* ModalNames.TRANSFER_CASH_CONFIRM */.s.TRANSFER_CASH_CONFIRM,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.TRANSFER_CASH_SUCCESS */.s.TRANSFER_CASH_SUCCESS);
                },
                onBack: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.TRANSFER_CASH */.s.TRANSFER_CASH);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transfer_TransferCashSuccess, {
                visible: modal === modal_store/* ModalNames.TRANSFER_CASH_SUCCESS */.s.TRANSFER_CASH_SUCCESS,
                onCancel: closeModal,
                onSubmit: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferCashBalanceReview, {
                visible: modal === modal_store/* ModalNames.TRANSFER_CASH_BALANCE_REVIEW */.s.TRANSFER_CASH_BALANCE_REVIEW,
                onCancel: closeModal,
                onSubmit: closeModal,
                onBack: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.TRANSFER_CASH */.s.TRANSFER_CASH);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transfer_TransferStock, {
                visible: modal === modal_store/* ModalNames.TRANSFER_STOCK */.s.TRANSFER_STOCK,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.TRANSFER_STOCK_CONFIRM */.s.TRANSFER_STOCK_CONFIRM);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferStockConfirm, {
                visible: modal === modal_store/* ModalNames.TRANSFER_STOCK_CONFIRM */.s.TRANSFER_STOCK_CONFIRM,
                onCancel: closeModal,
                onSubmit: function() {
                    closeModal();
                    setModal(modal_store/* ModalNames.TRANSFER_STOCK_SUCCESS */.s.TRANSFER_STOCK_SUCCESS);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Transfer_TransferStockSuccess, {
                visible: modal === modal_store/* ModalNames.TRANSFER_STOCK_SUCCESS */.s.TRANSFER_STOCK_SUCCESS,
                onCancel: closeModal,
                onSubmit: closeModal
            })
        ]
    });
};


/***/ }),

/***/ 65361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSubAccounts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34385);
/* harmony import */ var global_Securities_types_api_multiPorto__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96909);



function useSubAccounts() {
    var ref, ref1;
    var subAccountsData = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.subAccountsData;
    });
    var activeAccount = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.activeAccount;
    });
    var getSubAccounts = (0,lib_stores_multiPorto__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.getSubAccounts;
    });
    var subAccounts = (subAccountsData === null || subAccountsData === void 0 ? void 0 : (ref = subAccountsData.data) === null || ref === void 0 ? void 0 : ref.sub_accounts) || [];
    var canCreatePortfolio = subAccountsData === null || subAccountsData === void 0 ? void 0 : (ref1 = subAccountsData.data) === null || ref1 === void 0 ? void 0 : ref1.can_create_new_sub_account;
    var subAccountError = subAccountsData === null || subAccountsData === void 0 ? void 0 : subAccountsData.error;
    var approvedSubAccounts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return subAccounts.filter(function(sub) {
            return sub.account_status === global_Securities_types_api_multiPorto__WEBPACK_IMPORTED_MODULE_2__/* .SubAccountStatus.APPROVED */ .go.APPROVED;
        });
    }, [
        JSON.stringify(subAccounts)
    ]);
    var activePortfolio = subAccounts.find(function(sub) {
        return sub.account_number === activeAccount;
    });
    var activeAccountName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (subAccounts.length > 1 && activePortfolio) {
            return activePortfolio.portfolio_info.portfolio_name || "";
        }
        return "";
    }, [
        activePortfolio === null || activePortfolio === void 0 ? void 0 : activePortfolio.portfolio_info.portfolio_name,
        subAccounts.length
    ]);
    return {
        subAccounts: subAccounts,
        approvedSubAccounts: approvedSubAccounts,
        canCreatePortfolio: canCreatePortfolio,
        subAccountError: subAccountError,
        activeAccountName: activeAccountName,
        getSubAccounts: getSubAccounts
    };
};


/***/ }),

/***/ 74981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSwitchAction; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3683);
/* harmony import */ var _useSubAccounts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65361);




function useSwitchAction() {
    var setModal = (0,features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(s) {
        return s.openModal;
    });
    var getSubAccounts = (0,_useSubAccounts__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().getSubAccounts;
    var onOpenTransferCash = function() {
        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.TRANSFER_CASH */ .s.TRANSFER_CASH);
    };
    var onOpenTransferStock = function() {
        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.TRANSFER_STOCK */ .s.TRANSFER_STOCK);
    };
    var onCreatePortfolio = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data, canCreatePortfolio;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return getSubAccounts();
                    case 3:
                        data = _ctx.sent;
                        canCreatePortfolio = data.can_create_new_sub_account;
                        if (canCreatePortfolio) {
                            _ctx.next = 8;
                            break;
                        }
                        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.PORTFOLIO_CREATE_BLOCKED */ .s.PORTFOLIO_CREATE_BLOCKED);
                        return _ctx.abrupt("return");
                    case 8:
                        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.PORTFOLIO_CREATE */ .s.PORTFOLIO_CREATE);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    11
                ]
            ]);
        }));
        return function onCreatePortfolio() {
            return _ref.apply(this, arguments);
        };
    }();
    var onOpenTransferSelect = function() {
        setModal(features_multi_porto_stores_modal_store__WEBPACK_IMPORTED_MODULE_1__/* .ModalNames.TRANSFER_SELECT */ .s.TRANSFER_SELECT);
    };
    return {
        onOpenTransferCash: onOpenTransferCash,
        onOpenTransferStock: onOpenTransferStock,
        onCreatePortfolio: onCreatePortfolio,
        onOpenTransferSelect: onOpenTransferSelect
    };
};


/***/ }),

/***/ 17921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ formatShiftedCurrency; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "VZ": function() { return /* binding */ getMostMinMaxAmountRules; },
/* harmony export */   "_j": function() { return /* binding */ adjustCursorPosition; },
/* harmony export */   "bF": function() { return /* binding */ updateCursorPosition; },
/* harmony export */   "i$": function() { return /* binding */ isOverDailyLimit; },
/* harmony export */   "iM": function() { return /* binding */ formatPricePercentage; },
/* harmony export */   "kI": function() { return /* binding */ isUnderDailyLimit; },
/* harmony export */   "qF": function() { return /* binding */ formatBondDate; },
/* harmony export */   "uJ": function() { return /* binding */ formatBondCurrency; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);


// eslint-disable-next-line import/prefer-default-export
var formatBondDate = function(date) {
    if (!date) {
        return "-";
    }
    var formatFullMonthId = Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });
    return formatFullMonthId.format(new Date(date));
};
var formatBondCurrency = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "IDR";
    return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(value).replace(/\s+/g, "");
};
var formatPricePercentage = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never";
    if (typeof value !== "number") {
        return "-";
    }
    var rawValue = value / 100;
    return Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(rawValue);
};
var formatCurrency = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rp";
    return "".concat(currency).concat(Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    }));
};
var formatShiftedCurrency = function(value) {
    var fixZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, fractionDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Rp";
    var isNegative = value <= 0;
    var absoluteValue = Math.abs(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
    var formattedValue = "".concat(currency).concat(absoluteValue);
    if (fixZero && value === 0) return "".concat(formattedValue);
    return "".concat(isNegative ? "- " : "").concat(formattedValue);
};
var formatPrice = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
};
var formatNumber = function(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
};
var isOverDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && remaining < amount.min && (inputValue > remaining || inputValue > dailyMax);
};
var isUnderDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && inputValue <= dailyMax && remaining >= amount.min && inputValue > remaining;
};
var getMostMinMaxAmountRules = function(methods) {
    if (methods === null || methods === void 0 ? void 0 : methods.length) {
        var _Math, _Math1;
        var amounts = methods.map(function(method) {
            return method.amount;
        });
        var min = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.min;
        })));
        var max = (_Math1 = Math).max.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.max;
        })));
        return {
            min: min,
            max: max
        };
    }
    return {
        min: 0,
        max: 0
    };
};
var updateCursorPosition = function(event, newCursorPosition) {
    window.requestAnimationFrame(function() {
        var inputElement = event.target;
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
    });
};
var adjustCursorPosition = function(event, cursorPosition, originalValue, formattedValue) {
    var commaCountBefore = originalValue.slice(0, cursorPosition).split(",").length - 1;
    var commaCountAfter = formattedValue.slice(0, cursorPosition).split(",").length - 1;
    var adjustment = commaCountAfter - commaCountBefore;
    var newCursorPosition = formattedValue === "0" ? 1 : cursorPosition + adjustment;
    updateCursorPosition(event, newCursorPosition);
};


/***/ }),

/***/ 3897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export isElementTypeOf */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var isElementTypeOf = function(target, element) {
    return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(target) && target.type === element;
};
var Else = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
var If = function(props) {
    var condition = props.condition, children = props.children;
    if (condition) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children).filter(function(child) {
                return !isElementTypeOf(child, Else);
            })
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child) {
        if (isElementTypeOf(child, Else)) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(child);
        }
        return null;
    });
};
If.Else = Else;
/* harmony default export */ __webpack_exports__["Z"] = (If);


/***/ }),

/***/ 59359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ exodusApiInstance; }
/* harmony export */ });
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68425);
/* harmony import */ var global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);


var exodusApiInstance = {
    defaultInstance: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(),
    disabledErrorAlert: (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false),
    withLanguageInstance: function() {
        var language = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : global_Securities_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA, disableErrorAlert = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(disableErrorAlert, undefined, false, {
            "Accept-Language": language
        });
    }
};


/***/ }),

/***/ 95248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LY": function() { return /* binding */ postTnCAcceptance; },
/* harmony export */   "Y5": function() { return /* binding */ getTnCByFeature; },
/* harmony export */   "qo": function() { return /* binding */ postTnCAcceptances; },
/* harmony export */   "vj": function() { return /* binding */ getTnCByFeatures; }
/* harmony export */ });
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53850);
/* harmony import */ var _types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13114);
/* harmony import */ var _instance_exodus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59359);



var getTnCByFeature = function(featureId) {
    return _instance_exodus__WEBPACK_IMPORTED_MODULE_2__/* .exodusApiInstance.withLanguageInstance */ .l.withLanguageInstance(_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA).get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_0__/* .termsAndConditionsEndpoint.getTnCByFeature */ .Lr.getTnCByFeature(featureId));
};
var postTnCAcceptance = function(featureId, version, isAccepted) {
    return _instance_exodus__WEBPACK_IMPORTED_MODULE_2__/* .exodusApiInstance.withLanguageInstance */ .l.withLanguageInstance(_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA).post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_0__/* .termsAndConditionsEndpoint.postTnCAcceptance */ .Lr.postTnCAcceptance(), {
        acceptance_letters: [
            {
                feature_id: featureId,
                is_accepted: isAccepted,
                version: version
            }, 
        ]
    });
};
// terms and condition v2
var getTnCByFeatures = function(featureIds) {
    return _instance_exodus__WEBPACK_IMPORTED_MODULE_2__/* .exodusApiInstance.withLanguageInstance */ .l.withLanguageInstance(_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA).get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_0__/* .termsAndConditionsAPI.getTnCByFeature */ .b4.getTnCByFeature(featureIds));
};
var postTnCAcceptances = function(acceptancePayload) {
    return _instance_exodus__WEBPACK_IMPORTED_MODULE_2__/* .exodusApiInstance.withLanguageInstance */ .l.withLanguageInstance(_types_termsAndCondition__WEBPACK_IMPORTED_MODULE_1__/* .AcceptanceLanguageEnum.BAHASA */ .$6.BAHASA).post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_0__/* .termsAndConditionsAPI.postTnCAcceptance */ .b4.postTnCAcceptance(), {
        acceptance_letters: acceptancePayload
    });
};


/***/ }),

/***/ 19254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  padding: 3px;\n\n  & > .ant-checkbox {\n    top: 0;\n\n    & > .ant-checkbox-inner {\n      width: 18px;\n      height: 18px;\n      border-radius: 4px;\n    }\n  }\n\n  & > .ant-checkbox-checked::after {\n    border-radius: 4px;\n  }\n\n  & > span:nth-child(2) {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-47b14e33-0"
})(_templateObject());
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 94550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIconSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 12 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M11 1.5l-10 10M1 1.5l10 10"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconSvg);


/***/ }),

/***/ 97077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_InputStepper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Securities/components/InputStepper/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: hidden;\n  border-radius: 2px;\n  border: 1px solid #dadada;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #f5f6f7;\n  width: 30px;\n  height: 32px;\n  border: none;\n  flex-shrink: 0;\n  transition: 0.3s opacity ease-out;\n  cursor: pointer;\n\n  &:disabled {\n    opacity: 0.75;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n\n  width: 100%;\n  border: solid #dadada;\n  border-width: 0 1px;\n  text-align: center;\n\n  outline: none;\n\n  &::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  & .ant-input-number-handler-wrap {\n    display: none;\n  }\n\n  & .ant-input-number-input-wrap {\n    display: flex;\n    align-items: center;\n\n    & input {\n      text-align: center;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var InputStepContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5b57c1c-0"
})(_templateObject());
var StepButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-5b57c1c-1"
})(_templateObject1());
var StepInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-5b57c1c-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/global/Securities/components/InputStepper/index.tsx
// TODO: Split InputStepper to InputNumber component







var InputStepper = function(_param) {
    var containerStyle = _param.containerStyle, _onChange = _param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _step = _param.step, step = _step === void 0 ? 1 : _step, _disableDecimal = _param.disableDecimal, disableDecimal = _disableDecimal === void 0 ? false : _disableDecimal, _containerClassName = _param.containerClassName, containerClassName = _containerClassName === void 0 ? "" : _containerClassName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "containerStyle",
        "onChange",
        "step",
        "disableDecimal",
        "containerClassName"
    ]);
    var ref, ref1;
    var ref2 = (0,react.useState)(((ref = props.value) === null || ref === void 0 ? void 0 : ref.toString()) || ((ref1 = props.defaultValue) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "0"), inputValue = ref2[0], setInputValue = ref2[1];
    var ref3 = (0,react.useState)(false), active = ref3[0], setActive = ref3[1];
    var ref4 = (0,react.useMemo)(function() {
        var min = props.min, max = props.max;
        return {
            minValue: min === undefined ? -Infinity : Number(min),
            maxValue: max === undefined ? Infinity : Number(max)
        };
    }, [
        props.min,
        props.max
    ]), minValue = ref4.minValue, maxValue = ref4.maxValue;
    var formatter = function(value) {
        return Intl.NumberFormat("en-US").format(value);
    };
    var parser = function(value) {
        // Purposefully hardcoded number only to get separator symbol
        var thousandSeparator = Intl.NumberFormat("en-US").format(1111).replace(/[0-9]+/g, "");
        var decimalSeparator = Intl.NumberFormat("en-US").format(1.1).replace(/[0-9]+/g, "");
        var ref = (0,_sliced_to_array/* default */.Z)(value.replaceAll(thousandSeparator, "").split(decimalSeparator), 2), wholeValue = ref[0], tmp = ref[1], decimalValue = tmp === void 0 ? 0 : tmp;
        return Number("".concat(wholeValue).concat(decimalSeparator).concat(decimalValue));
    };
    var parsedInputValue = (0,react.useMemo)(function() {
        return parser(inputValue);
    }, [
        inputValue
    ]);
    var setTextCursor = function(target, position) {
        window.requestAnimationFrame(function() {
            target.focus();
            target.setSelectionRange(position, position);
        });
    };
    var getStep = function(key) {
        return step[key] || step;
    };
    // Clamp value optionally, set to Infinity to handle unclamped value
    var getClampedValue = function(value) {
        return Math.min(Math.max(value, minValue), maxValue);
    };
    var getProcessedValue = function(value) {
        var parsedValue = getClampedValue(parser(value));
        return {
            rawValue: parsedValue,
            formattedValue: formatter(parsedValue)
        };
    };
    var handleChange = function(e) {
        var value = e.target.value;
        var isReplaceZero = parsedInputValue === 0;
        var ref = getProcessedValue(isReplaceZero ? value.replace("0", "") : value), rawValue = ref.rawValue, formattedValue = ref.formattedValue;
        var selectionPos = e.target.selectionStart;
        // Handle on value not convertible to number
        if (Number.isNaN(rawValue)) return;
        // Handle when inputing decimal
        if (value[value.length - 1] === "." && !inputValue.includes(".") && !disableDecimal) {
            setInputValue("".concat(formattedValue, "."));
            return;
        }
        // Handle on removing comma
        if (formattedValue === inputValue) {
            // Check if the last character removed was '0'
            if (inputValue === "0" && selectionPos === 0) {
                // Set the cursor to the right of '0'
                setTextCursor(e.target, selectionPos + 1);
                return;
            }
            setTextCursor(e.target, selectionPos);
            return;
        }
        setInputValue(formattedValue);
        onChange(rawValue);
        // Prevent cursor jumping when adding and removing text
        var shiftPos = inputValue.length - value.length;
        var newCursor = selectionPos + (formattedValue.length - inputValue.length + shiftPos);
        setTextCursor(e.target, newCursor);
    };
    var handleStepDown = function() {
        var stepValue = getStep("down");
        var rawValue = getClampedValue(parsedInputValue - stepValue);
        setInputValue(formatter(rawValue));
        onChange(rawValue);
    };
    var handleStepUp = function() {
        var stepValue = getStep("up");
        var rawValue = getClampedValue(parsedInputValue + stepValue);
        setInputValue(formatter(rawValue));
        onChange(rawValue);
    };
    var handlePropValueChange = (0,react.useCallback)(function() {
        if (props.value === undefined) return;
        var newValue = formatter(getClampedValue(props.value || 0));
        setInputValue(newValue);
    }, [
        props.value
    ]);
    (0,react.useEffect)(function() {
        handlePropValueChange();
    }, [
        handlePropValueChange
    ]);
    var containerClass = "".concat(containerClassName, " ").concat(active ? "active" : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputStepContainer, {
        className: containerClass,
        style: containerStyle,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepButton, {
                type: "button",
                "data-cy": "btn-step-down",
                onClick: handleStepDown,
                disabled: parsedInputValue <= minValue || props.disabled,
                children: "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                "data-cy": "input-step"
            }, props), {
                onChange: handleChange,
                value: inputValue,
                onBlur: function() {
                    return setActive(false);
                },
                onFocus: function() {
                    return setActive(true);
                }
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StepButton, {
                type: "button",
                "data-cy": "btn-step-up",
                onClick: handleStepUp,
                disabled: parsedInputValue >= maxValue || props.disabled,
                children: "+"
            })
        ]
    });
};
/* harmony default export */ var components_InputStepper = (InputStepper);


/***/ }),

/***/ 48871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_BaseSecuritiesModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 19 modules
var modal = __webpack_require__(33070);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/CloseIconSvg.tsx
var CloseIconSvg = __webpack_require__(94550);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-body {\n    padding: 24px 0 0;\n  }\n\n  & .ant-modal-close-x {\n    width: 50px;\n    margin-top: 6px;\n\n    :hover .anticon {\n      color: #b5b5b5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #c1c1c1;\n  font-size: 10px;\n  transition: 0.3s color linear;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  line-height: normal;\n  color: #333333;\n  margin: 0 0 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  transform: translate(0, 100%);\n  width: 100%;\n  height: unset;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-0"
})(_templateObject());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).attrs({
    component: CloseIconSvg/* default */.Z
}).withConfig({
    componentId: "sc-d885cbc0-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-d885cbc0-2"
})(_templateObject2());
var FloatingButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx





var BaseSecuritiesModal = function(_param) /*#__PURE__*/ {
    var title = _param.title, submitText = _param.submitText, onSubmit = _param.onSubmit, submitProps = _param.submitProps, hideSubmit = _param.hideSubmit, children = _param.children, _modalWidth = _param.modalWidth, modalWidth = _modalWidth === void 0 ? 500 : _modalWidth, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "submitText",
        "onSubmit",
        "submitProps",
        "hideSubmit",
        "children",
        "modalWidth"
    ]);
    return (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: modalWidth,
        footer: null,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
        centered: true
    }, props), {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            children,
            !hideSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "primary",
                onClick: onSubmit
            }, submitProps), {
                children: submitText
            }))
        ]
    }));
};
/* harmony default export */ var Modal_BaseSecuritiesModal = (BaseSecuritiesModal);


/***/ }),

/***/ 24383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14671);
/* harmony import */ var zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42435);
/* harmony import */ var lib_api_trade__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65141);
/* harmony import */ var stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7639);
/* harmony import */ var _types_termsAndCondition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13114);
/* harmony import */ var _api_termsAndConditions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95248);











var initialState = {
    contents: undefined,
    isSubmitting: false,
    termsData: undefined,
    accountStatus: ""
};
var useTermsAndConditionStore = (0,zustand__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)((0,zustand_middleware_immer__WEBPACK_IMPORTED_MODULE_6__/* .immer */ .n)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, initialState), {
        loadTnC: function loadTnC(featureId, onAgreementPending, onAgreementAccepted) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, isAccepted;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,_api_termsAndConditions__WEBPACK_IMPORTED_MODULE_4__/* .getTnCByFeature */ .Y5)(featureId);
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            isAccepted = data.acceptance_letters.length === 0;
                            set(function(draft) {
                                draft.contents = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, draft.contents), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, featureId, {
                                    isAccepted: isAccepted,
                                    acceptanceLetters: data.acceptance_letters
                                }));
                            });
                            if (isAccepted) {
                                _ctx.next = 10;
                                break;
                            }
                            onAgreementPending();
                            return _ctx.abrupt("return");
                        case 10:
                            onAgreementAccepted();
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        },
        postAcceptance: function postAcceptance(featureId, version) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set(function(draft) {
                                draft.isSubmitting = true;
                            });
                            _ctx.next = 4;
                            return (0,_api_termsAndConditions__WEBPACK_IMPORTED_MODULE_4__/* .postTnCAcceptance */ .LY)(featureId, version, true);
                        case 4:
                            set(function(draft) {
                                draft.contents[featureId].isAccepted = true;
                                draft.isSubmitting = false;
                            });
                            _ctx.next = 11;
                            break;
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            set(function(draft) {
                                draft.contents[featureId].isAccepted = false;
                                draft.isSubmitting = false;
                            });
                            Promise.reject(_ctx.t0);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }))();
        },
        loadTnCAcceptance: // terms and condition v2
        function loadTnCAcceptance(featureIds) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, acceptanceLetters, isDayTradeAccepted;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return (0,_api_termsAndConditions__WEBPACK_IMPORTED_MODULE_4__/* .getTnCByFeatures */ .vj)(featureIds);
                        case 3:
                            response = _ctx.sent;
                            data = response.data.data;
                            acceptanceLetters = data.acceptance_letters;
                            acceptanceLetters.forEach(function(letter) {
                                set(function(draft) {
                                    draft.termsData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, draft.termsData), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, letter.feature_id, {
                                        isAccepted: letter.is_accepted,
                                        url: letter.url,
                                        version: letter.version
                                    }));
                                });
                                var storeKey = _types_termsAndCondition__WEBPACK_IMPORTED_MODULE_3__/* .TnCFeaturePersistMap */ .rO[letter.feature_id];
                                stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue(storeKey, letter.is_accepted);
                            });
                            isDayTradeAccepted = stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().getUIValue("dayTradeTnc");
                            return _ctx.abrupt("return", isDayTradeAccepted);
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        11
                    ]
                ]);
            }))();
        },
        postAcceptances: function postAcceptances(acceptances) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            set(function(draft) {
                                draft.isSubmitting = true;
                            });
                            _ctx.prev = 1;
                            _ctx.next = 4;
                            return (0,_api_termsAndConditions__WEBPACK_IMPORTED_MODULE_4__/* .postTnCAcceptances */ .qo)(acceptances);
                        case 4:
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            return _ctx.abrupt("return", true);
                        case 8:
                            _ctx.prev = 8;
                            _ctx.t0 = _ctx["catch"](1);
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", false);
                        case 13:
                            _ctx.prev = 13;
                            set(function(draft) {
                                draft.isSubmitting = false;
                            });
                            return _ctx.finish(13);
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        8,
                        13,
                        16
                    ]
                ]);
            }))();
        },
        loadSubAccountStatus: function loadSubAccountStatus(type) {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, _data, tmp, sub_account, status, isActive, storeKey;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return lib_api_trade__WEBPACK_IMPORTED_MODULE_1__/* ["default"].checkSubAccountDayTrade */ .Z.checkSubAccountDayTrade(type);
                        case 3:
                            response = _ctx.sent;
                            _data = response.data, tmp = _data.data, sub_account = (tmp === void 0 ? {} : tmp).sub_account;
                            status = (sub_account || {}).status;
                            set(function(draft) {
                                draft.accountStatus = status;
                            });
                            isActive = status === _types_termsAndCondition__WEBPACK_IMPORTED_MODULE_3__/* .SubAccountStatus.ACTIVE */ .go.ACTIVE;
                            storeKey = "dayTradeSubAccountActive";
                            stores_useUIConfigStore__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getState */ .Z.getState().setUIValue(storeKey, isActive);
                            return _ctx.abrupt("return", isActive);
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            Promise.reject(_ctx.t0);
                            return _ctx.abrupt("return", true);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }))();
        }
    });
}));
/* harmony default export */ __webpack_exports__["Z"] = (useTermsAndConditionStore);


/***/ }),

/***/ 96909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "go": function() { return /* binding */ SubAccountStatus; }
/* harmony export */ });
/* unused harmony exports SubAccountPurpose, CanotCreateReason */
var SubAccountStatus;
(function(SubAccountStatus) {
    SubAccountStatus["PENDING"] = "ACCOUNT_STATUS_PENDING";
    SubAccountStatus["APPROVED"] = "ACCOUNT_STATUS_APPROVED";
    SubAccountStatus["REJECTED"] = "ACCOUNT_STATUS_REJECTED";
})(SubAccountStatus || (SubAccountStatus = {}));
var SubAccountPurpose;
(function(SubAccountPurpose) {
    SubAccountPurpose["TRADING"] = "PURPOSE_TRADING";
    SubAccountPurpose["LONG_TERM_INVESTING"] = "PURPOSE_LONG_TERM_INVESTING";
    SubAccountPurpose["SHORT_TERM_INVESTING"] = "PURPOSE_SHORT_TERM_INVESTING";
})(SubAccountPurpose || (SubAccountPurpose = {}));
var CanotCreateReason;
(function(CanotCreateReason) {
    CanotCreateReason["INSUFFICIENT"] = "REASON_TYPE_INSUFFICIENT_EQUITY_AMOUNT";
    CanotCreateReason["MAX_REACHED"] = "REASON_TYPE_MAX_SUB_ACCOUNT_REACHED";
})(CanotCreateReason || (CanotCreateReason = {}));


/***/ }),

/***/ 91037:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ActionTarget; },
/* harmony export */   "F4": function() { return /* binding */ PlatformOrderTypes; },
/* harmony export */   "IC": function() { return /* binding */ OrderSecuritiesKindType; },
/* harmony export */   "iX": function() { return /* binding */ OrderAction; },
/* harmony export */   "l5": function() { return /* binding */ ForcedSellMapper; },
/* harmony export */   "oU": function() { return /* binding */ OrderSide; },
/* harmony export */   "pD": function() { return /* binding */ OrderForceSellType; },
/* harmony export */   "pY": function() { return /* binding */ SecuritiesKind; },
/* harmony export */   "vT": function() { return /* binding */ iOrderSide; }
/* harmony export */ });
/* unused harmony exports OrderStatus, LeverageType */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var SecuritiesKind;
(function(SecuritiesKind) {
    SecuritiesKind[SecuritiesKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SecuritiesKind[SecuritiesKind["STOCK"] = 1] = "STOCK";
    SecuritiesKind[SecuritiesKind["BOND"] = 2] = "BOND";
})(SecuritiesKind || (SecuritiesKind = {}));
var OrderSecuritiesKindType;
(function(OrderSecuritiesKindType) {
    OrderSecuritiesKindType["Unspecified"] = "SECURITIES_KIND_UNSPECIFIED";
    OrderSecuritiesKindType["Stock"] = "SECURITIES_KIND_STOCK";
    OrderSecuritiesKindType["Bond"] = "SECURITIES_KIND_BOND";
})(OrderSecuritiesKindType || (OrderSecuritiesKindType = {}));
var PlatformOrderTypes;
(function(PlatformOrderTypes) {
    PlatformOrderTypes["UNSPECIFIED"] = "PLATFORM_ORDER_TYPE_UNSPECIFIED";
    PlatformOrderTypes["LIMIT"] = "PLATFORM_ORDER_TYPE_LIMIT_DAY";
    PlatformOrderTypes["FAK"] = "PLATFORM_ORDER_TYPE_MARKET_FAK";
    PlatformOrderTypes["FAST_ORDER"] = "PLATFORM_ORDER_TYPE_FAST_ORDER";
})(PlatformOrderTypes || (PlatformOrderTypes = {}));
var OrderAction;
(function(OrderAction) {
    OrderAction["Buy"] = "BUY";
    OrderAction["Sell"] = "SELL";
})(OrderAction || (OrderAction = {}));
var iOrderSide;
(function(iOrderSide) {
    iOrderSide[iOrderSide["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    iOrderSide[iOrderSide["BUY"] = 1] = "BUY";
    iOrderSide[iOrderSide["SELL"] = 2] = "SELL";
})(iOrderSide || (iOrderSide = {}));
var OrderSide;
(function(OrderSide) {
    OrderSide["Unspecified"] = "SIDE_UNSPECIFIED";
    OrderSide["Buy"] = "SIDE_BUY";
    OrderSide["Sell"] = "SIDE_SELL";
})(OrderSide || (OrderSide = {}));
var OrderStatus;
(function(OrderStatus) {
    OrderStatus["Ready"] = "READY";
    OrderStatus["Open"] = "OPEN";
    OrderStatus["Partial"] = "PARTIAL";
    OrderStatus["Rejected"] = "REJECTED";
    OrderStatus["Pending"] = "PENDING";
    OrderStatus["Active"] = "ACTIVE";
    OrderStatus["RequestAmend"] = "REQUEST AMEND";
})(OrderStatus || (OrderStatus = {}));
var OrderForceSellType;
(function(OrderForceSellType) {
    OrderForceSellType["Unspecified"] = "DAY_TRADE_FORCE_SELL_UNSPECIFIED";
    OrderForceSellType["DebtRatio"] = "DAY_TRADE_FORCE_SELL_DEBT_RATIO";
    OrderForceSellType["TimeLimit"] = "DAY_TRADE_FORCE_SELL_TIME_LIMIT";
})(OrderForceSellType || (OrderForceSellType = {}));
var LeverageType;
(function(LeverageType) {
    LeverageType["Unspecified"] = "LEVERAGE_TYPE_TRADING_UNSPECIFIED";
    LeverageType["TradingBalance"] = "LEVERAGE_TYPE_TRADING_BALANCE";
    LeverageType["TradingLimit"] = "LEVERAGE_TYPE_TRADING_LIMIT";
    LeverageType["BasicLimit"] = "LEVERAGE_TYPE_BASIC_LIMIT";
    LeverageType["TempLimit"] = "LEVERAGE_TYPE_TEMP_LIMIT";
    LeverageType["DayTrade"] = "LEVERAGE_TYPE_DAY_TRADE";
})(LeverageType || (LeverageType = {}));
var _obj;
var ForcedSellMapper = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.DebtRatio, "FORCED SELL"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, OrderForceSellType.TimeLimit, "FORCED SELL"), _obj);
var ActionTarget;
(function(ActionTarget) {
    ActionTarget["UNSPECIFIED"] = "ACTION_TARGET_UNSPECIFIED";
    ActionTarget["REGULAR"] = "ACTION_TARGET_REGULAR";
    ActionTarget["DAY_TRADE"] = "ACTION_TARGET_DAY_TRADE";
    ActionTarget["LEGACY_SMARTORDER"] = "ACTION_TARGET_LEGACY_SMARTORDER";
    ActionTarget["TRAILING_STOP"] = "ACTION_TARGET_TRAILING_STOP";
    ActionTarget["STOP_ORDER"] = "ACTION_TARGET_STOP_ORDER";
    ActionTarget["BRACKET_ORDER"] = "ACTION_TARGET_BRACKET_ORDER";
})(ActionTarget || (ActionTarget = {}));


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 89237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hc": function() { return /* binding */ convertSmartOrderConfigType; },
/* harmony export */   "KH": function() { return /* binding */ convertSecuritiesKind; },
/* harmony export */   "TQ": function() { return /* binding */ lotFormatter; },
/* harmony export */   "a$": function() { return /* binding */ getExercisedData; },
/* harmony export */   "aF": function() { return /* binding */ getHourFromTimestamp; },
/* harmony export */   "gg": function() { return /* binding */ convertTimestampToDate; },
/* harmony export */   "hK": function() { return /* binding */ getTime; },
/* harmony export */   "y0": function() { return /* binding */ convertBooleanToNumber; },
/* harmony export */   "zn": function() { return /* binding */ convertForceSellEvent; }
/* harmony export */ });
/* unused harmony exports formatToLocalDate, convertGoogleDateToTimestamp */
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78343);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42298);
/* harmony import */ var global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91037);


var HOUR_OFFSET = -7;
var convertBooleanToNumber = function(bool) {
    return bool ? 1 : 0;
};
var formatToLocalDate = function(date, customFormat) {
    var adjustedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(date, HOUR_OFFSET);
    var formattedHour = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(adjustedDate, customFormat);
    return formattedHour;
};
var convertTimestampToDate = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "yyyy-MM-dd HH:mm:ss");
};
var convertGoogleDateToTimestamp = function(date) {
    if (!date) return "";
    var year = date.year, month = date.month, day = date.day;
    var jsDate = new Date(year, month - 1, day + 1);
    return formatToLocalDate(jsDate, "dd-MM-yyyy");
};
var getHourFromTimestamp = function(time) {
    if (!time) return "";
    var jsDate = new Date(time);
    return formatToLocalDate(jsDate, "HH:mm:ss");
};
var getTime = function(timestamp) {
    if (!timestamp) return "";
    return Number(timestamp.seconds) * 1000;
};
var getExercisedData = function(exercise) {
    if (!exercise) return null;
    var active = exercise.active, type = exercise.type, price = exercise.price, info = exercise.info, date = exercise.date;
    return {
        active: active,
        type: type,
        price: price,
        info: info,
        listing_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.listing),
        expired_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.expired),
        mature_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.mature),
        exercise_start_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.start),
        exercise_end_date: convertGoogleDateToTimestamp(date === null || date === void 0 ? void 0 : date.end)
    };
};
var convertForceSellEvent = function(event) {
    switch(event){
        case 1:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.DebtRatio */ .pD.DebtRatio;
        case 2:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.TimeLimit */ .pD.TimeLimit;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderForceSellType.Unspecified */ .pD.Unspecified;
    }
};
var convertSmartOrderConfigType = function(configType) {
    switch(configType){
        case "CONFIG_PRICE_TYPE_ABOVE":
            return "1";
        case "CONFIG_PRICE_TYPE_BELOW":
            return "2";
        default:
            return configType;
    }
};
var convertSecuritiesKind = function(kind) {
    switch(kind){
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.STOCK */ .pY.STOCK:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Stock */ .IC.Stock;
        case global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .SecuritiesKind.BOND */ .pY.BOND:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Bond */ .IC.Bond;
        default:
            return global_Securities_types_store_order__WEBPACK_IMPORTED_MODULE_0__/* .OrderSecuritiesKindType.Unspecified */ .IC.Unspecified;
    }
};
var lotFormatter = function(value) {
    return Intl.NumberFormat("en-US").format(value);
};


/***/ })

}]);